<template>
  <div class="dashboard-container">
    <!-- Header -->
    <div class="dashboard-header sticky-header">
      <a-card>
        <a-col>
          <a-space
            class="header sticky"
            style="width: 100%; justify-content: space-between; flex-wrap: wrap; gap: 10px;"
          >
            <h3>แดชบอร์ด</h3>
            <a-row
              :gutter="[16, 16]"
              style="align-items: center; flex-wrap: wrap;"
            >
              <!-- <a-col>
                <div class="pill-switch">
                  <span
                    v-for="item in ['รายวัน','รายเดือน','รายปี']"
                    :key="item"
                    :class="{ active: activePeriod === item }"
                    @click="!isChartBuilding && (activePeriod = item, updateChart())"
                  >
                    {{ item }}
                  </span>
                </div>
              </a-col> -->
              <a-col>
                <a-range-picker v-model:value="selectedDate" style="width: 100%" :picker="datePickerType" @change="updateChart()" @click="!isChartBuilding"/>
              </a-col>
              <!-- <a-col>
                <a-select v-model:value="selectedView" style="width: 160px" placeholder="มุมมองผู้บริหาร" @change="updateChart()">
                  <a-select-option value="operation">มุมมองผู้ปฏิบัติการ</a-select-option>
                  <a-select-option value="admin">มุมมองผู้บริหาร</a-select-option>
                </a-select>
              </a-col> -->
            </a-row>
          </a-space>
        </a-col>
        <a-col style="margin-top: 12px;">
          <div class="dashboard-pill-group">
            <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
              <a-row
                :gutter="[16, 16]"
                style="align-items: center; flex-wrap: wrap;"
              >
                <a-space style="margin-right: 20px;">
                  <span>ประเภทรถ:</span>
                  <div class="pill-switch">
                      <span
                        v-for="item in ['ทั้งหมด','รถบริษัท','รถร่วม']"
                        :key="item"
                        :class="{ active: activeCarCom === item }"
                        @click="!isChartBuilding && (activeCarCom = item, updateChart())"
                      >
                        {{ item }}
                      </span>
                  </div>
                </a-space>
                <a-space>
                  <span>ประเภทธุรกิจ:</span>
                  <div class="pill-switch-2">
                      <span
                        v-for="item in ['ทั้งหมด','โรงงาน','ขนส่ง']"
                        :key="item"
                        :class="{ active: activeBusiness === item }"
                        @click="activeBusiness = item"
                      >
                        {{ item }}
                      </span>
                  </div>
                </a-space>
              </a-row>
              <a-space v-show="activeBusiness !== 'ทั้งหมด' || activeCarCom !== 'ทั้งหมด'">
                <span>ตัวกรองที่เลือก:</span>
                <a-tag
                  v-show="activeCarCom !== 'ทั้งหมด'"
                  color="blue"
                >
                  {{ activeCarCom }}
                </a-tag>
                <a-tag
                  v-show="activeBusiness !== 'ทั้งหมด'"
                  color="purple"
                >
                  {{ activeBusiness }}
                </a-tag>
                <a-typography-link style="text-decoration: underline; font-size: 12px;" @click="activeCarCom = 'ทั้งหมด'; activeBusiness = 'ทั้งหมด'; updateChart()">
                  ล้างทั้งหมด
                </a-typography-link>
              </a-space>
            </div>
          </div>
        </a-col>
      </a-card> 
    </div>

    <!-- Summary Cards -->
    <div class="summary-cards">
      <a-row :gutter="16" style="margin-right: 2%; margin-left: 2%; margin-bottom: 15px;">
        <a-col :xs="24" :sm="12" :md="12" :lg="6" style="text-align: center;">
          <a-card hoverable style="border-radius: 12px; background-color: #dbeafe; border: solid 1px #bedbff;">
            <a-space direction="vertical" style="align-items: center;">
              <a-avatar
                class="avatar-icon-2"
                style="background-color: #2b7fff;width: 50px;height: 50px;"
              >
                <span class="material-symbols-outlined" style="color: white; font-size: 180%;">assignment</span>
              </a-avatar>
              <span class="card-title" style="font-weight: bold;">งานทั้งหมด</span>
              <span class="card-value" style="font-weight: 600;">{{bookingCount || 0}}</span>
            </a-space>
          </a-card>
        </a-col>

        <a-col :xs="24" :sm="12" :md="12" :lg="6" style="text-align: center;">
          <a-card hoverable style="border-radius: 12px; background-color: #dcfce780; border: solid 1px #b9f8cf;">
            <a-space direction="vertical" style="align-items: center;">
              <a-avatar
                class="avatar-icon-2"
                style="background-color: #00c951;width: 50px;height: 50px;"
              >
                <span class="material-symbols-outlined" style="color: white; font-size: 180%;">account_balance_wallet</span>
              </a-avatar>
              <span class="card-title" style="font-weight: bold;">รายได้</span>
              <span class="card-value" style="font-weight: 600;">{{ incomeSum || 0 }}</span>
            </a-space>
          </a-card>
        </a-col>

        <a-col :xs="24" :sm="12" :md="12" :lg="6" style="text-align: center;">
          <a-card hoverable style="border-radius: 12px; background-color: #ffedd480; border: solid 1px #ffd6a8;">
            <a-space direction="vertical" style="align-items: center;">
              <a-avatar
                class="avatar-icon-2"
                style="background-color: #ff6900;width: 50px;height: 50px;"
              >
                <span class="material-symbols-outlined" style="color: white; font-size: 180%;">credit_card</span>
              </a-avatar>
              <span class="card-title" style="font-weight: bold;">ค่าใช้จ่าย</span>
              <span class="card-value" style="font-weight: 600;">{{ outcomeSum || 0 }}</span>
            </a-space>
          </a-card>
        </a-col>

        <a-col :xs="24" :sm="12" :md="12" :lg="6" style="text-align: center;">
          <a-card hoverable style="border-radius: 12px; background-color: #ffe2e280; border: solid 1px #ffc9c9;">
            <a-space direction="vertical" style="align-items: center;">
              <a-avatar
                class="avatar-icon-2"
                style="background-color: #fb2c36;width: 50px;height: 50px;"
              >
                <span class="material-symbols-outlined" style="color: white; font-size: 180%;">error</span>
              </a-avatar>
              <span class="card-title" style="font-weight: bold;">ค้างชำระ</span>
              <span class="card-value" style="font-weight: 600;">{{ waitingForInvoice }}</span>
            </a-space>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="16" style="margin-right: 2%; margin-left: 2%;">
        <a-col :xs="24" :sm="12" :md="12" :lg="6">
          <a-card :style="statusBusinessStyle(statusBusiness(3).color)" >
            <div class="card-content">
              <a-space direction="vertical" style="font-size: 14px; width: 100%;">
                <span class="card-title" style="font-size: 14px; font-weight: bold;">โรงงาน และ ขนส่ง</span>
                  <a-space style="width: 100%; justify-content: space-between">
                    <span>จำนวนใบงาน</span>
                    <span style="font-weight: bold;">{{ countFunction(sheetFilter?.filter((item)=>item.booking_business_type_id == 3)) }}</span>
                  </a-space>
                  <a-space style="width: 100%; justify-content: space-between">
                    <span>รายได้</span>
                    <span style="font-weight: bold;">฿{{ incomeSumFunction(sheetFilter?.filter((item)=>item.booking_business_type_id == 3)) }}</span>
                  </a-space>
                  <a-space style="width: 100%; justify-content: space-between">
                    <span>จำนวนรถ</span>
                    <span style="font-weight: bold;">{{ countCar(sheetFilter?.filter((item)=>item.booking_business_type_id == 3)) }}</span>
                  </a-space>
              </a-space>
            </div>
          </a-card>
        </a-col>

        <a-col :xs="24" :sm="12" :md="12" :lg="6">
          <a-card :style="statusBusinessStyle(statusBusiness(1).color)">
            <div class="card-content">
              <a-space direction="vertical" style="font-size: 14px; width: 100%;">
                <span class="card-title" style=" font-weight: bold;">โรงงาน</span>
                <a-space style="width: 100%; justify-content: space-between">
                  <span>จำนวนใบงาน</span>
                  <span style="font-weight: bold;">{{ countFunction(sheetFilter?.filter((item)=>item.booking_business_type_id == 1)) }}</span>
                </a-space>
                <a-space style="width: 100%; justify-content: space-between">
                  <span>รายได้</span>
                  <span style="font-weight: bold;">฿{{ incomeSumFunction(sheetFilter?.filter((item)=>item.booking_business_type_id == 1)) }}</span>
                </a-space>
                <a-space style="width: 100%; justify-content: space-between">
                  <span>จำนวนรถ</span>
                  <span style="font-weight: bold;">{{countCar(sheetFilter?.filter((item)=>item.booking_business_type_id == 1))}}</span>
                </a-space>
              </a-space>
            </div>
          </a-card>
        </a-col>

        <a-col :xs="24" :sm="12" :md="12" :lg="6">
          <a-card :style="statusBusinessStyle(statusBusiness(2).color)">
            <div class="card-content">
              <a-space direction="vertical" style="font-size: 14px; width: 100%;">
                <span class="card-title" style="font-size: 14px; font-weight: bold;">ขนส่ง</span>
                <a-space style="width: 100%; justify-content: space-between">
                  <span>จำนวนใบงาน</span>
                  <span style="font-weight: bold;">{{ countFunction(sheetFilter?.filter((item)=>item.booking_business_type_id == 2)) }}</span>
                </a-space>
                <a-space style="width: 100%; justify-content: space-between">
                  <span>รายได้</span>
                  <span style="font-weight: bold;">฿{{ incomeSumFunction(sheetFilter?.filter((item)=>item.booking_business_type_id == 2)) }}</span>
                </a-space>
                <a-space style="width: 100%; justify-content: space-between">
                  <span>จำนวนรถ</span>
                  <span style="font-weight: bold;">{{countCar(sheetFilter?.filter((item)=>item.booking_business_type_id == 2))}}</span>
                </a-space>
              </a-space>
            </div>
          </a-card>
        </a-col>

        <a-col :xs="24" :sm="12" :md="12" :lg="6">
          <a-card :style="statusBusinessStyle(statusBusiness(4).color)">
            <div class="card-content">
              <a-space direction="vertical">
                <div>
                  <span class="card-title" style="font-size: 14px; font-weight: bold;">รวมทั้งหมด </span>
                  <br/>
                  <span style="font-size: 14px;">ทุกประเภทธุรกิจ</span>
                </div>
                <div style="font-size: 20px; font-weight: bold;">
                    <span>฿{{incomeSum}}</span>
                </div>
              </a-space>
            </div>
          </a-card>
        </a-col>

      </a-row>
      <!-- Chart Section -->
      <a-card style="margin-top: 20px; border-radius: 12px;">
        <div class="chart-header">
          <a-space style="width: 100%; justify-content: space-between">
            <a-space class="chart-title" style="font-size: 20px;">
              <span class="material-symbols-outlined" style="font-size: 25px; color: #1677ff;">trending_up</span>
              <span style="font-weight: 500;">รายได้ vs ค่าใช้จ่าย</span>
            </a-space>

            <div class="pill-switch">
              <span
                v-for="item in ['รายวัน','รายเดือน','รายปี']"
                :key="item"
                :class="{ active: activeChartPeriod === item }"
                @click="!isChartBuilding && (activeChartPeriod = item, updateChart())"
              >
                {{ item }}
              </span>
            </div>
          </a-space>
        </div>

        <div class="chart-body">
          <canvas ref="income_outcome"  style=" max-height: 300px;"></canvas>        
        </div>
      </a-card>
      <a-row :gutter="16" style="margin-top: 20px;">
        <a-col :xs="24" :md="24" :lg="12">
          <a-card style="border-radius: 12px; width: 100%; height: 470px;">
            <div class="card-content">
              <a-space direction="vertical" style="width: 100%;">
                <div>
                  <span class="card-title" style="font-size: 20px;">รายได้แยกตามประเภทธุรกิจ</span>
                  <br/>
                  <span style="font-size: 14px; color: rgba(0, 0, 0, 0.45);">สัดส่วนตามประเภท</span>
                </div>
                <div class="chart-body" style="display: flex; justify-content: center;">
                  <canvas ref="business_income" style="max-width: 250px; max-height: 250px;"></canvas>        
                </div>
                <div class="custom-legend">
                  <div
                    v-for="item in legendData"
                    :key="item.label"
                    class="legend-row"
                  >
                    <div class="legend-left">
                      <span
                        class="legend-dot"
                        :style="{ backgroundColor: item.color }"
                      ></span>
                      <span>{{ item.label }}</span>
                    </div>
                    <span class="legend-value">{{ item.value }}%</span>
                  </div>
                </div>
              </a-space>
            </div>
          </a-card>
        </a-col>

        <a-col :xs="24" :md="24" :lg="12">
          <a-card style="border-radius: 12px; width: 100%; height: 470px;">
            <div class="card-content">
              <a-space direction="vertical" style="width: 100%;">
                <div>
                  <span class="card-title" style="font-size: 20px;">รายได้แยกตามประเภทรถ</span>
                  <br/>
                  <span style="font-size: 14px; color: rgba(0, 0, 0, 0.45);">รถบริษัท vs รถร่วม</span>
                </div>
                <div class="chart-body" style="display: flex; justify-content: center;">
                  <canvas ref="cartype_income" style="max-width: 250px; max-height: 250px;"></canvas>        
                </div>
                <div class="custom-legend">
                  <div
                    v-for="item in legendData2"
                    :key="item.label"
                    class="legend-row"
                  >
                    <div class="legend-left">
                      <span
                        class="legend-dot"
                        :style="{ backgroundColor: item.color }"
                      ></span>
                      <span>{{ item.label }}</span>
                    </div>
                    <span class="legend-value">{{ item.value }}%</span>
                  </div>
                </div>
              </a-space>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :xs="24" :md="24" :lg="12">
          <a-card title="รายงานรถ" class="custom-card-header" style="width: 100%; border-radius: 10px; margin-top: 12px;" >
            <template #extra>
              <div 
                style="font-size: 14px;"
                class="view-all"
                @click="openTableModal({
                  title: 'รายงานรถทั้งหมด',
                  subTitle: `แสดง ${dataTripVehicleFilter?.length} รายการ`,
                  columns: columnsTripVehicle,
                  data: dataTripVehicleFilter,
                  loading: loadingTripVehicle,
                  typeData: 'trip_vehicle'
                })">
                ทั้งหมด  > 
              </div>
            </template>
            <div class="chart-content-table">
                <a-table
                  class="custom-table"
                  :columns="columnsTripVehicle"
                  :data-source="dataTripVehicleFilter.slice(0,5)"
                  :pagination="false"
                  :loading="loadingTripVehicle"
                  :scroll="{ x: 'calc(100px + 10%)'}"
                  size="small"
                >
                <template #bodyCell="{ column, record, index }">
                </template>
              </a-table>
            </div>
          </a-card>
        </a-col>
        <a-col :xs="24" :md="24" :lg="12">
          <a-card title="รายงานคนขับ" class="custom-card-header" style="width: 100%; border-radius: 10px; margin-top: 12px;" >
            <template #extra>
              <div 
                style="font-size: 14px;"
                class="view-all"
                @click="openTableModal({
                  title: 'รายงานคนขับทั้งหมด',
                  subTitle: `แสดง ${dataTripDriverFilter?.length} รายการ`,
                  columns: columnsTripDriver,
                  data: dataTripDriverFilter,
                  loading: loadingTripDriver,
                  typeData: 'trip_driver'
                })">
                ทั้งหมด  > 
              </div>
            </template>
            <div class="chart-content-table">
                <a-table
                  class="custom-table"
                  :columns="columnsTripDriver"
                  :data-source="dataTripDriverFilter.slice(0,5)"
                  :pagination="false"
                  :loading="loadingTripDriver"
                  :scroll="{ x: 'calc(100px + 10%)'}"
                  @change="handleTableChangeTripDriver"
                  size="small"
                >
                <template #bodyCell="{ column, record, index }">
                </template>
              </a-table>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-card title="งานที่กำลังดำเนินการ" class="custom-card-header" style="width: 100%; border-radius: 10px; margin-top: 12px;" >
            <template #extra>
              <div 
                style="font-size: 14px;"
                class="view-all"
                @click="openTableModal({
                  title: 'งานที่กำลังดำเนินการทั้งหมด',
                  subTitle: `แสดง ${filterAndGroupByFullname(paginatedDataWorking)?.length} รายการ`,
                  columns: columnsTripSheet,
                  data: filterAndGroupByFullname(paginatedDataWorking),
                  loading: loadingTripSheet,
                  typeData: 'trip_sheet',
                })">
                ทั้งหมด  > 
              </div>
            </template>
            <div class="chart-content-table">
                <a-table
                class="custom-table"
                :columns="columnsTripSheet"
                :data-source="filterAndGroupByFullname(paginatedDataWorking).slice(0,5)"
                :pagination="false"
                :loading="loadingTripSheet"
                :scroll="{ x: 800 }"
                size="small"
              >
                <template #bodyCell="{ column, record, index }">
                  <template v-if="column.key === 'day'">
                      {{ 6 }}
                  </template>
                  <template v-if="column.key === 'status'">
                    <div v-if="statusCar(record) && isHexColor(statusCar(record).color)" :style="statusStyle(statusCar(record).color)">
                      {{ statusCar(record).txt }}
                    </div>
                    <a-tag v-else-if="statusCar(record)" :color="statusCar(record).color">
                      {{ statusCar(record).txt }}
                    </a-tag>
                  </template>
                  <template v-if="column.key === 'business_type'">
                    <div :style="statusStyle(statusBusiness(record?.business_type).color)">
                      {{ statusBusiness(record?.business_type).txt }}
                    </div>
                  </template>
                </template>
              </a-table>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <!-- <div v-if="selectedView == 'admin'"> -->
        <a-divider style="height: 2px; background-color: #1677ff" />
         <!-- <a-row>
          <div class="card-content" style="border-radius: 12px; width: 100%; margin-bottom: 20px; padding: 10px; background-color: #eff6ff; border: #bedbff solid 1px;">
            <a-space style="width: 100%; justify-content: space-between">
              <a-space direction="vertical">
                <span class="card-title" style="font-size: 18px; color: #1C398E;">โมดูลวิเคราะห์ธุรกิจสำหรับผู้บริหาร</span>
                <span style="font-size: 14px; color: #1447E6;">การวิเคราะห์และข้อมูลเชิงลึก</span>
              </a-space>
              <div style="border-radius: 12px; width: 110px; padding: 5px; background-color: #1677ff; color: white; text-align: center;">
                มุมมองผู้บริหาร
              </div>
            </a-space>
          </div>
        </a-row> -->
        <a-row :gutter="16">
          <a-col :span="24">
            <a-card class="custom-card-header most-car" style="width: 100%; border-radius: 10px; margin-top: 12px; padding: 0px;">
              <template #title>
                <span class="card-title" style="font-size: 20px;">
                  5 อันดับรถที่ทำงานมากที่สุด
                </span>
                <br />
                <span style="font-size: 14px; color: rgba(255, 255, 255, 0.8);">
                  วิเคราะห์รายได้ รายจ่าย และกำไรต่อทะเบียนรถ
                </span>
              </template>
              <template #extra>
                <div 
                  style="font-size: 14px;"
                  class="view-all"
                  @click="openTableModal({
                    title: 'รถทั้งหมดเรียงตามชั่วโมงทำงาน',
                    subTitle: `แสดง ${dataTopFiveVehicleFilter?.length} ทะเบียน`,
                    footer: true,
                    columns: columnsMostTrip,
                    pagination: false,
                    data: dataTopFiveVehicleFilter,
                    loading: loadingMostTrip,
                    typeData: 'most_trip',
                  })">
                  ทั้งหมด  > 
                </div>
              </template>
              <div class="chart-content-table" style=" width: 100%;">
                  <a-table
                    class="custom-table"
                    :columns="columnsMostTrip"
                    :data-source="dataTopFiveVehicleFilter.slice(0,5)"
                    :pagination="false"
                    :loading="loadingMostTrip"
                    :scroll="{ x: 'calc(500px + 10%)' }"
                    size="small"
                  >
                  <template #headerCell="{ column }">
                    <template v-if="column.key === 'marginCar'">
                      <a-tooltip title="ต้นทุนรถ/รายได้ (%): (รวมจ่าย ÷ รายได้) × 100 — ยิ่งน้อยยิ่งดี">
                        <span style="cursor: help;">
                          {{ column.title }}
                        </span>
                      </a-tooltip>
                    </template>
                    <template v-if="column.key === 'marginIncome'">
                      <a-tooltip title="กำไร/รายได้ (%): (กำไร ÷ รายได้) × 100 — ยิ่งมากยิ่งดี">
                        <span style="cursor: help;">
                          {{ column.title }}
                        </span>
                      </a-tooltip>
                    </template>
                  </template>
                  <template #bodyCell="{ column, record, index }">
                    <template v-if="column.key === 'income'">
                      <span style="color: #008236;">฿{{ Number(record.income).toLocaleString('en-US') }}</span>
                    </template>
                    <template v-if="column.key === 'gas_cost' || column.key === 'repair_cost'">
                      <span style="color: #ca3500;">฿{{ Number(record[column.key]).toLocaleString('en-US') }}</span>
                    </template>
                    <template v-if=" column.key === 'total_cost'">
                      <span style="color: #c10007;">฿{{ Number(record[column.key]).toLocaleString('en-US') }}</span>
                    </template>
                    <template v-if="column.key === 'benefit'">
                      <span :style="`color: ${record.benefit >= 0 ? '#008236' : '#c10007'}`">฿{{ Number(record.benefit).toLocaleString('en-US') }}</span>
                    </template>
                  </template>
                </a-table>
              </div>
              <a-row style="margin-top: 12px; font-size: 12px; margin-left: 12px;" :gutter="8" align="middle">
                <a-col :span="4" style="text-align: left;">
                  <span>รายได้รวม: <span style="color: #008236;"> ฿{{ Number(dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.income || 0), 0)).toLocaleString('en-US') }}</span></span>
                </a-col>
                <a-col :span="1" style="text-align: left;">
                  <a-divider type="vertical" style="height: 24px;" />
                </a-col>
                <a-col :span="4" style="text-align: left;">
                  <span>น้ำมันรวม: <span style="color: #c10007;"> ฿{{ Number(dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.gas_cost || 0), 0)).toLocaleString('en-US') }}</span></span>
                </a-col>
                <a-col :span="1" style="text-align: left;">
                  <a-divider type="vertical" style="height: 24px;" />
                </a-col>
                <a-col :span="4" style="text-align: left;">
                  <span>ซ่อมบำรุงรวม: <span style="color: #c10007;"> ฿{{ Number(dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.repair_cost || 0), 0)).toLocaleString('en-US') }}</span></span>
                </a-col>
                <a-col :span="1" style="text-align: left;">
                  <a-divider type="vertical" style="height: 24px;" />
                </a-col>
                <a-col :span="4" style="text-align: left;">
                  <span>รายจ่ายรวม: <span style="color: #c10007;"> ฿{{ Number(dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.total_cost || 0), 0)).toLocaleString('en-US') }}</span></span>
                </a-col>
                <a-col :span="1" style="text-align: left;">
                  <a-divider type="vertical" style="height: 24px;" />
                </a-col>
                <a-col :span="4" style="text-align: left;">
                  <span>กำไรรวม: <span style="color: #008236;"> ฿{{ Number(dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.benefit || 0), 0)).toLocaleString('en-US') }}</span></span>
                </a-col>
              </a-row>
            </a-card>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="margin-top: 10px;">
          <a-col :xs="24" :md="24" :lg="12">
            <a-card style="background-color: #f4f9ff; border: solid 2px #dbeafe;margin-bottom: 15px; border-radius: 12px;">
              <div style="margin-bottom: 15px;">
                <a-space style="width: 100%; justify-content: space-between;">
                  <a-space>
                    <a-avatar
                      shape="square"
                      class="avatar-icon"
                      style="background-color: #1677ff;width: 50px;height: 50px;"
                    >
                      <span class="material-symbols-outlined" style="color: white; font-size: 30px;">group</span>
                    </a-avatar>
                    <div>
                      <span style="font-size: 18px; font-weight: normal;">การเข้างานคนขับ</span>
                      <br/>
                      <span style="font-size: 14px; color:rgba(0, 0, 0, 0.45); font-weight: normal;"><span class="material-symbols-outlined" style="font-size: 16px;">location_on</span>เช็คอินได้ทุกที่</span>
                    </div>
                  </a-space>
                  <div style="border-radius: 12px; width: 60px; background-color: #DBEAFE; padding: 5px; color: #1677ff; text-align: center;">
                    คนขับ
                  </div>
                </a-space>
              </div>
              <a-row align="middle">
                <a-col :xs="28" :sm="14" :md="14" :lg="7" style="text-align: center;">
                  <a-card style="border-radius: 12px;">
                    <a-space direction="vertical">
                       <a-avatar
                        class="avatar-icon-2"
                        style="background-color: #F3F4F6;width: 50px;height: 50px;"
                      >
                        <span class="material-symbols-outlined" style="color: #4A5565; font-size: 30px;">group</span>
                      </a-avatar>
                      <span style="font-size: 24px; font-weight: bold;">{{dataSumDriverFilter?.length||0}}</span>
                      <span>ทั้งหมด</span>
                    </a-space>
                  </a-card>
                </a-col>

                <a-col :span="1" style="text-align: center;">
                  <a-divider type="vertical" style="height: 48px;" />
                </a-col>

                <a-col :xs="28" :sm="14" :md="14" :lg="8" style="text-align: center;">
                  <a-card style="border-radius: 12px; background-color: #F0FDF4;">
                    <a-space direction="vertical">
                       <a-avatar
                        class="avatar-icon-2"
                        style="background-color: #DCFCE7;width: 50px;height: 50px;"
                      >
                        <span class="material-symbols-outlined" style="color: #3f8600; font-size: 30px;">group</span>
                      </a-avatar>
                      <span style="font-size: 24px; font-weight: bold;color: #3f8600;">{{ dataSumDriverFilter?.filter(item => item?.time && item.leave_type == null)?.length || 0 }}</span>
                      <span>เข้างาน</span>
                    </a-space>
                  </a-card>
                </a-col>

                <a-col :span="1" style="text-align: center;">
                  <a-divider type="vertical" style="height: 48px;" />
                </a-col>

                <a-col :xs="28" :sm="14" :md="14" :lg="7" style="text-align: center;">
                  <a-card style="border-radius: 12px; background-color: #FEF2F2;">
                    <a-space direction="vertical">
                       <a-avatar
                        class="avatar-icon-2"
                        style="background-color: #FFE2E2;width: 50px;height: 50px;"
                      >
                        <span class="material-symbols-outlined" style="color: #cf1322; font-size: 30px;">group</span>
                      </a-avatar>
                      <span style="font-size: 24px; font-weight: bold;color: #cf1322;">{{ dataSumDriverFilter?.length - (dataSumDriverFilter?.filter(item => item?.time && item.leave_type == null)?.length || 0) || 0 }}</span>
                      <span>ไม่อยู่</span>
                    </a-space>
                  </a-card>
                </a-col>
              </a-row>
              <a-button 
                style="margin-top: 15px; width: 100%; border-radius: 10px; padding: 20px; background-color: #1677ff;"
                @click="openTableModal({
                    title: 'ประวัติการเข้างานคนขับ',
                    subTitle: `${selectedDate[0].isSame(selectedDate[1]) ? formatThaiDate(selectedDate[1]) : formatThaiDate(currentDate)}`,
                    footer: true,
                    columns: columnsCheckInDriver,
                    data: dataSumDriverFilter,
                    loading: loadingCheckInDriver,
                    typeData: 'checkin_driver'
                  })">
                  <a-space>
                    <span class="material-symbols-outlined" style="color: white; font-size: 16px; margin-top: 6px;">schedule</span>
                    <span style="color: white;">ดูประวัติรายละเอียด</span>
                  </a-space>
              </a-button>
            </a-card>
          </a-col>

          <a-col :xs="24" :md="24" :lg="12">
            <a-card style="background-color: #fcf9ff; border: solid 2px #F3E8FF;margin-bottom: 15px; border-radius: 12px;">
              <div style="margin-bottom: 15px;">
                <a-space style="width: 100%; justify-content: space-between;">
                  <a-space>
                    <a-avatar
                      shape="square"
                      class="avatar-icon"
                      style="background-color: #AD46FF;width: 50px;height: 50px;"
                    >
                      <span class="material-symbols-outlined" style="color: white; font-size: 30px;">group</span>
                    </a-avatar>
                    <div>
                      <span style="font-size: 18px; font-weight: normal;">การเข้างานออฟฟิศ</span>
                      <br/>
                      <span style="font-size: 14px; color:rgba(0, 0, 0, 0.45); font-weight: normal;"><span class="material-symbols-outlined" style="font-size: 16px;">location_on</span>รัศมี 50 เมตร</span>
                    </div>
                  </a-space>
                  <div style="border-radius: 12px; width: 60px; background-color: #F3E8FF; padding: 5px; color: #AD46FF; text-align: center;">
                    ออฟฟิศ
                  </div>
                </a-space>
              </div>
              <a-row align="middle">
                <a-col :xs="28" :sm="14" :md="14" :lg="7" style="text-align: center;">
                  <a-card style="border-radius: 12px;">
                    <a-space direction="vertical">
                       <a-avatar
                        class="avatar-icon-2"
                        style="background-color: #F3F4F6;width: 50px;height: 50px;"
                      >
                        <span class="material-symbols-outlined" style="color: #4A5565; font-size: 30px;">group</span>
                      </a-avatar>
                      <span style="font-size: 24px; font-weight: bold;">{{ paginatedDataSumEmp?.length || 0 }}</span>
                      <span>ทั้งหมด</span>
                    </a-space>
                  </a-card>
                </a-col>

                <a-col :span="1" style="text-align: center;">
                  <a-divider type="vertical" style="height: 48px;" />
                </a-col>

                <a-col :xs="28" :sm="14" :md="14" :lg="8" style="text-align: center;">
                  <a-card style="border-radius: 12px; background-color: #F0FDF4;">
                    <a-space direction="vertical">
                       <a-avatar
                        class="avatar-icon-2"
                        style="background-color: #DCFCE7;width: 50px;height: 50px;"
                      >
                        <span class="material-symbols-outlined" style="color: #3f8600; font-size: 30px;">group</span>
                      </a-avatar>
                      <span style="font-size: 24px; font-weight: bold;color: #3f8600;">{{paginatedDataSumEmp?.filter((item)=>item.status == 'เข้างาน').length || 0}}</span>
                      <span>เข้างาน</span>
                    </a-space>
                  </a-card>
                </a-col>

                <a-col :span="1" style="text-align: center;">
                  <a-divider type="vertical" style="height: 48px;" />
                </a-col>

                <a-col :xs="28" :sm="14" :md="14" :lg="7" style="text-align: center;">
                  <a-card style="border-radius: 12px; background-color: #FEF2F2;">
                    <a-space direction="vertical">
                       <a-avatar
                        class="avatar-icon-2"
                        style="background-color: #FFE2E2;width: 50px;height: 50px;"
                      >
                        <span class="material-symbols-outlined" style="color: #cf1322; font-size: 30px;">group</span>
                      </a-avatar>
                      <span style="font-size: 24px; font-weight: bold;color: #cf1322;">{{ paginatedDataSumEmp?.filter((item)=>item.status != 'เข้างาน').length || 0 }}</span>
                      <span>ไม่อยู่</span>
                    </a-space>
                  </a-card>
                </a-col>
              </a-row>
              <a-button 
                style="margin-top: 15px; width: 100%; border-radius: 10px; padding: 20px; background-color: #AD46FF;"
                @click="openTableModal({
                    title: 'ประวัติการเข้างานออฟฟิศ',
                    subTitle: `${ selectedDate[0].isSame(selectedDate[1]) ? formatThaiDate(selectedDate[1]) : formatThaiDate(currentDate)}`,
                    footer: true,
                    columns: columnsCheckInOffice,
                    data: paginatedDataSumEmp,
                    loading: loadingCheckInOffice,
                    typeData: 'checkin_office'
                  })">
                  <a-space>
                    <span class="material-symbols-outlined" style="color: white; font-size: 16px; margin-top: 6px;">schedule</span>
                    <span style="color: white;">ดูประวัติรายละเอียด</span>
                  </a-space>
              </a-button>
            </a-card>
          </a-col>
        </a-row>
      <!-- </div> -->
    </div>
    <a-modal
      v-model:visible="modalVisible" width="80%"
      class="rounded-modal"
      :footer="modalFooter ? undefined : null"
    >
      <template #title>
        <a-space direction="vertical">
          <a-space v-if="modalTypeData == 'checkin_driver' || modalTypeData == 'checkin_office'" align="center">
            <a-avatar
              shape="square"
              class="avatar-icon"
              :style="modalTypeData == 'checkin_driver' ? 'background-color: #1677ff;width: 35px;height: 35px;' : 'background-color: #AD46FF;width: 35px;height: 35px;'"
            >
              <span class="material-symbols-outlined" style="color: white; font-size: 20px;">group</span>
            </a-avatar>
            <a-space direction="vertical">
              <span style="font-size: 18px; font-weight: 500;">{{ modalTitle }}</span>
              <div>
                <span class="material-symbols-outlined" style="font-size: 14px; color:rgba(0, 0, 0, 0.6); font-weight: normal;">schedule</span>
                <span style="font-size: 14px; color:rgba(0, 0, 0, 0.6); font-weight: normal;">{{modalSubtitle}}</span>
              </div>
            </a-space>
          </a-space>
          <a-space direction="vertical" v-else>
            <span style="font-size: 18px; font-weight: 500;">{{ modalTitle }}</span>
            <span style="font-size: 14px; color:rgba(0, 0, 0, 0.6); font-weight: normal;">{{modalSubtitle}}</span>
          </a-space>
        </a-space>
      </template>
      <a-table
        :columns="modalColumns"
        :data-source="modalData"
        :loading="modalLoading"
        :row-class-name="modalTypeData != 'checkin_driver' ? rowClassName : () => ''"
        :pagination="false"
        :scroll="{ x: 800, y: 'calc(100vh - 300px)' }"
        size="middle"
      >
        <template #headerCell="{ column }">
          <template v-if="column.key === 'marginCar'">
            <a-tooltip title="ต้นทุนรถ/รายได้ (%): (รวมจ่าย ÷ รายได้) × 100 — ยิ่งน้อยยิ่งดี">
              <span style="cursor: help;">
                {{ column.title }}
              </span>
            </a-tooltip>
          </template>
          <template v-if="column.key === 'marginIncome'">
            <a-tooltip title="กำไร/รายได้ (%): (กำไร ÷ รายได้) × 100 — ยิ่งมากยิ่งดี">
              <span style="cursor: help;">
                {{ column.title }}
              </span>
            </a-tooltip>
          </template>
        </template>
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'index'">
            <div :class="['rank-badge', { top5: record.index <= 5 && modalTypeData === 'most_trip' }]">
              {{ record.index }}
            </div>
          </template>
          <template v-if="column.key === 'status'">
            <!-- For check-in modals show styled pills for เข้างาน / ยังไม่เข้างาน -->
            <div v-if="modalTypeData === 'checkin_driver' || modalTypeData === 'checkin_office'">
              <div v-if="record?.status === 'เข้างาน'" class="status-pill status-in">
                <span class="material-symbols-outlined pill-icon">person_check</span>
                <span class="pill-text">เข้างาน</span>
              </div>
              <div v-else-if="record?.status === 'ยังไม่เข้างาน' || record?.status === 'ไม่อยู่' || !record?.status" class="status-pill status-out">
                <span class="material-symbols-outlined pill-icon">person_cancel</span>
                <span class="pill-text">ยังไม่เข้างาน</span>
              </div>
              <div v-else class="status-pill status-neutral">
                <span class="pill-text">{{ record.status }}</span>
              </div>
            </div>
            <!-- Fallback to existing statusCar handling for other modal types -->
            <div v-else>
              <div v-if="statusCar(record) && isHexColor(statusCar(record).color)" :style="statusStyle(statusCar(record).color)">
                {{ statusCar(record).txt }}
              </div>
              <a-tag v-else-if="statusCar(record)" :color="statusCar(record).color">
                {{ statusCar(record).txt }}
              </a-tag>
            </div>
          </template>
          <template v-if="column.key === 'business_type'">
            <div :style="statusStyle(statusBusiness(record?.business_type).color)">
              {{ statusBusiness(record?.business_type).txt }}
            </div>
          </template>
          <template v-if="column.key === 'plate_no'">
            <a-tag color="#f6f3f4" style="font-size: 14px; padding: 4px 8px; color:black">
              {{ record.plate_no }}
            </a-tag>
          </template>
          <template v-if="column.key === 'time'">
            <span v-if="record?.time" class="material-symbols-outlined" style="color: #99a1af; font-size: 16px;">schedule</span>
            {{ record.time }}
          </template>
          <template v-if="column.key === 'time_out'">
            <span v-if="record?.time" class="material-symbols-outlined" style="color: #99a1af; font-size: 16px;">schedule</span>
            {{ record.time_out }}
          </template>
          <template v-if="column.key === 'gps'">
            <span v-if="record?.gps" class="material-symbols-outlined" style="color: #99a1af; font-size: 16px;">location_on</span>
            <span style="font-size: 12px;">{{ record.gps }}</span><br/>
            <span v-if="record?.gps_out" class="material-symbols-outlined" style="color: #99a1af; font-size: 16px;">location_on</span>
            <span v-if="record?.gps_out" style="font-size: 12px;">{{ record.gps_out }}</span>
          </template>
          <template v-if="column.key === 'distance'">
            <span> {{ distanceText(record?.distance) }} </span>
            <span v-if="record?.distance_out">,<br/>{{ distanceText(record?.distance_out) }} </span>
          </template>
          <template v-if="column.key === 'remark'">
            <div v-if="record?.driver">
              <span> {{ record?.remark ?? '-' }}</span>
            </div>
            <div v-else-if="record?.time">
              <span> เช็คอิน : {{ record?.remark ? 'นอกรัศมีที่กำหนด' : '-'}} </span><br/>
              <span v-if="record?.time_out"> เช็คเอาต์ : {{ record?.remark_out? 'นอกรัศมีที่กำหนด' : '-' }} </span>
            </div>
          </template>
          <template v-if="column.key === 'income' && modalTypeData === 'most_trip'">
            <span style="color: #008236;">฿{{ Number(record.income).toLocaleString('en-US') }}</span>
          </template>
          <template v-if="column.key === 'gas_cost' || column.key === 'repair_cost'">
            <span style="color: #ca3500;">฿{{ Number(record[column.key]).toLocaleString('en-US') }}</span>
          </template>
          <template v-if=" column.key === 'total_cost'">
            <span style="color: #c10007;">฿{{ Number(record[column.key]).toLocaleString('en-US') }}</span>
          </template>
          <template v-if="column.key === 'benefit'">
            <span :style="`color: ${record.benefit >= 0 ? '#008236' : '#c10007'}`">฿{{ Number(record.benefit).toLocaleString('en-US') }}</span>
          </template>
        </template>
      </a-table>
      <a-row v-if="modalTypeData == 'most_trip'" style="width: 100%; margin-top: 10px;">
        <a-col :span="4" style="text-align: left;">
          <span>รายได้รวม <br/> <span style="color: #008236;"> ฿{{ dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.income || 0), 0) }}</span></span>
        </a-col>
        <a-col :span="1" style="text-align: left;">
          <a-divider type="vertical" style="height: 24px;" />
        </a-col>
        <a-col :span="4" style="text-align: left;">
          <span>น้ำมันรวม <br/> <span style="color: #c10007;"> ฿{{ dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.gas_cost || 0), 0) }}</span></span>
        </a-col>
        <a-col :span="1" style="text-align: left;">
          <a-divider type="vertical" style="height: 24px;" />
        </a-col>
        <a-col :span="4" style="text-align: left;">
          <span>ซ่อมบำรุงรวม <br/> <span style="color: #c10007;"> ฿{{ dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.repair_cost || 0), 0) }}</span></span>
        </a-col>
        <a-col :span="1" style="text-align: left;">
          <a-divider type="vertical" style="height: 24px;" />
        </a-col>
        <a-col :span="4" style="text-align: left;">
          <span>รายจ่ายรวม <br/> <span style="color: #c10007;"> ฿{{ dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.total_cost || 0), 0) }}</span></span>
        </a-col>
        <a-col :span="1" style="text-align: left;">
          <a-divider type="vertical" style="height: 24px;" />
        </a-col>
        <a-col :span="4" style="text-align: left;">
          <span>กำไรรวม <br/> <span style="color: #008236;"> ฿{{ dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.benefit || 0), 0) }}</span></span>
        </a-col>
      </a-row>
      <template #footer>
        <a-space v-if="modalTypeData == 'most_trip'" style="width: 100%; justify-content: space-between;">
            <span>Margin เฉลี่ย: <span style="font-weight: 600;"> {{Number(dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.marginIncome || 0), 0) / dataTopFiveVehicleFilter.length || 0).toFixed(2)}}%</span></span>
            <span>ชั่วโมงรวม: <span style="font-weight: 600;"> {{dataTopFiveVehicleFilter?.reduce((sum, item) => sum + Number(item?.hours || 0), 0) || 0}} ชม.</span></span>
        </a-space>
        <a-space v-else-if="modalTypeData == 'checkin_driver'" style="width: 100%; justify-content: space-between;">
          <a-space>
            <span class="material-symbols-outlined" style="font-size: 14px; color:rgba(0, 0, 0, 0.6); font-weight: normal;">location_on</span>
            <span> นโยบาย: เช็คอินได้ทุกที่ (ไม่จำกัดระยะห่าง)</span>
            <div style="display:flex; gap:16px; align-items:center;">
              <div>
                <a-badge status="success" />
                เข้างาน: <span style="color:#3f8600">{{ dataSumDriverFilter?.filter(item => item.status === 'เข้างาน').length || 0 }}</span>
              </div>

              <div>
                <a-badge status="error" />
                ลา: <span style="color:#cf1322">{{ dataSumDriverFilter?.filter(item => item?.status?.includes('ลา')).length || 0 }}</span>
              </div>
            </div>
          </a-space>
          <a-button class="gradient-btn" shape="round" type="default" @click="export_file(modalData,modalTypeData)">
            <span class="material-symbols-outlined" style="font-size: 14px; color:white;">assignment_turned_in</span>
            <span>Export Excel</span>
          </a-button>
        </a-space>
        <a-space v-else-if="modalTypeData == 'checkin_office'" style="width: 100%; justify-content: space-between;">
          <a-space>
            <span class="material-symbols-outlined" style="font-size: 14px; color:rgba(0, 0, 0, 0.6); font-weight: normal;">location_on</span>
            <span> นโยบาย: ภายในรัศมี 50 เมตร</span>
            <div style="display:flex; gap:16px; align-items:center;">
              <div>
                <a-badge status="success" />
                เข้างาน: <span style="color:#3f8600">{{ paginatedDataSumEmp?.filter(item => item.status === 'เข้างาน').length || 0 }}</span>
              </div>

              <div>
                <a-badge status="error" />
                ลา: <span style="color:#cf1322">{{ paginatedDataSumEmp?.filter(item => item?.status?.includes('ลา')).length || 0 }}</span>
              </div>
            </div>
          </a-space>
          <a-button class="gradient-btn" shape="round" type="default" @click="export_file(modalData,modalTypeData)">
            <span class="material-symbols-outlined" style="font-size: 14px; color:white;">assignment_turned_in</span>
            <span>Export Excel</span>
          </a-button>
        </a-space>
      </template>
    </a-modal>
  </div>
</template>

<script>
import input_primary from "../../components/input_primary.vue";
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
// Guard Chart internals against null canvas/context to avoid uncaught TypeError
try {
  const _origClear = Chart.prototype.clear;
  Chart.prototype.clear = function(...args) {
    try {
      if (!this || !this.ctx || !this.ctx.canvas) return;
    } catch (e) {
      return;
    }
    return _origClear.apply(this, args);
  };
} catch (e) {
  // if patching fails, ignore - Chart will behave as before
  console.warn('Failed to patch Chart.clear:', e);
}
// Also guard draw and internal dataset draw to prevent Chart.js internals
try {
  const _origDraw = Chart.prototype.draw;
  if (_origDraw) {
    Chart.prototype.draw = function(...args) {
      try {
        if (!this || !this.ctx || !this.ctx.canvas) return;
      } catch (e) {
        return;
      }
      return _origDraw.apply(this, args);
    };
  }

  const _origDrawDataset = Chart.prototype._drawDataset;
  if (_origDrawDataset) {
    Chart.prototype._drawDataset = function(...args) {
      try {
        if (!this || !this.ctx || !this.ctx.canvas) return;
      } catch (e) {
        return;
      }
      return _origDrawDataset.apply(this, args);
    };
  }
} catch (e) {
  console.warn('Failed to patch Chart.draw/_drawDataset:', e);
}
import UserService from "../../api/UserService";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
dayjs.extend(buddhistEra);
import inputDatePicker from "../../components/input_date_picker.vue";
import SystemService from "../../api/SystemService";
import DriversChannelService from "../../api/DriversChannelService";
import socketService from "../../api/SocketService";
import SheetService from "../../api/SheetService";
import CompanyService from "../../api/CompanyService";
import CheckInHistoryService from "../../api/CheckInHistoryService";
import XLSX from "xlsx-js-style";

export default {
  components: { input_primary, inputDatePicker },
  name: "Dashboard",
  props: {
    company_data: Object,
  },
  computed: {
    sheetFilter() {
      let sheetData = this.sheetFetch;
      if(this.activePeriod == 'รายวัน') {
        sheetData = this.sheetFetch?.filter((item)=> dayjs(item.time_start).format('YYYY/MM/DD') >= this.selectedDate?.[0].format("YYYY/MM/DD")
                                                  &&  dayjs(item.time_start).format('YYYY/MM/DD') <= this.selectedDate?.[1].format("YYYY/MM/DD") );
      } else if(this.activePeriod == 'รายเดือน') {
        sheetData = this.sheetFetch?.filter((item)=> dayjs(item.time_start).format('YYYY/MM') >= this.selectedDate?.[0].format("YYYY/MM")
                                                  &&  dayjs(item.time_start).format('YYYY/MM') <= this.selectedDate?.[1].format("YYYY/MM") );
      } else if(this.activePeriod == 'รายปี') {
        sheetData = this.sheetFetch?.filter((item)=> dayjs(item.time_start).format('YYYY') >= this.selectedDate?.[0].format("YYYY")
                                                  &&  dayjs(item.time_start).format('YYYY') <= this.selectedDate?.[1].format("YYYY") );
      }
      if(this.activeCarCom == 'รถบริษัท'){
        sheetData = sheetData?.filter((item)=>item.company_3rd == 'บริษัทรถ' || item.company_3rd == null);
      }else if(this.activeCarCom == 'รถร่วม'){
        sheetData = sheetData?.filter((item)=>item.company_3rd == 'บริษัทรถร่วม');
      }

      if(this.activeBusiness == 'โรงงาน') {
        sheetData = sheetData?.filter((item) => item.booking_business_type_id == 1);
      } else if(this.activeBusiness == 'ขนส่ง') {
        sheetData = sheetData?.filter((item) => item.booking_business_type_id == 2);
      }
      return sheetData
    },
    dataTripDriverFilter(){
      let data = this.paginatedDataTripDriver;
      if(this.activeCarCom == 'รถบริษัท'){
        data = this.paginatedDataTripDriver?.filter((item)=>item.company_3rd == 'บริษัทรถ' || item.company_3rd == null);
      }else if(this.activeCarCom == 'รถร่วม'){
        data = this.paginatedDataTripDriver?.filter((item)=>item.company_3rd == 'บริษัทรถร่วม');
      }
      if(this.activeBusiness == 'โรงงาน') {
        data = data?.filter((item) => item.booking_business_type_id == 1);
      } else if(this.activeBusiness == 'ขนส่ง') {
        data = data?.filter((item) => item.booking_business_type_id == 2);
      }
      return data;
    },
    dataTripVehicleFilter(){
      let data = this.paginatedDataTripVehicle;
      if(this.activeCarCom == 'รถบริษัท'){
        data = this.paginatedDataTripVehicle?.filter((item)=>item.company_3rd == 'บริษัทรถ' || item.company_3rd == null);
      }else if(this.activeCarCom == 'รถร่วม'){
        data = this.paginatedDataTripVehicle?.filter((item)=>item.company_3rd == 'บริษัทรถร่วม');
      }
      if(this.activeBusiness == 'โรงงาน') {
        data = data?.filter((item) => item.booking_business_type_id == 1);
      } else if(this.activeBusiness == 'ขนส่ง') {
        data = data?.filter((item) => item.booking_business_type_id == 2);
      }
      return data;
    },
    dataTopFiveVehicleFilter(){
      let data = this.paginatedDataTopFiveVehicle;
      if(this.activeCarCom == 'รถบริษัท'){
        data = this.paginatedDataTopFiveVehicle?.filter((item)=>item.company_3rd == 'บริษัทรถ' || item.company_3rd == null);
      }else if(this.activeCarCom == 'รถร่วม'){
        data = this.paginatedDataTopFiveVehicle?.filter((item)=>item.company_3rd == 'บริษัทรถร่วม');
      }
      if(this.activeBusiness == 'โรงงาน') {
        data = data?.filter((item) => item.booking_business_type_id == 1);
      } else if(this.activeBusiness == 'ขนส่ง') {
        data = data?.filter((item) => item.booking_business_type_id == 2);
      }
      return data;
    },
    dataSumDriverFilter(){
      let data = this.paginatedDataSumDriver;
      if(this.activeCarCom == 'รถบริษัท'){
        data = this.paginatedDataSumDriver?.filter((item)=>item.company_3rd == 'บริษัทรถ' || item.company_3rd == null);
      }else if(this.activeCarCom == 'รถร่วม'){
        data = this.paginatedDataSumDriver?.filter((item)=>item.company_3rd == 'บริษัทรถร่วม');
      }
      return data;
    },
    modalData() {
      switch (this.modalTypeData) {

        case "trip_vehicle":
          return this.dataTripVehicleFilter

        case "trip_driver":
          return this.dataTripDriverFilter

        case "trip_sheet":
          return this.filterAndGroupByFullname(this.paginatedDataWorking)

        case "checkin_driver":
          return this.dataSumDriverFilter

        case "checkin_office":
          return this.paginatedDataSumEmp

        case "most_trip":
          return this.dataTopFiveVehicleFilter

        default:
          return []
      }
    },
    legendData() {
      const factoryTransport = Number(
        this.incomeSumBusinessFunction(
          this.sheetFilter?.filter(item => item.booking_business_type_id == 3)
        ) || 0
      );

      const factory = Number(
        this.incomeSumBusinessFunction(
          this.sheetFilter?.filter(item => item.booking_business_type_id == 1)
        ) || 0
      );

      const transport = Number(
        this.incomeSumBusinessFunction(
          this.sheetFilter?.filter(item => item.booking_business_type_id == 2)
        ) || 0
      );

      const total = factoryTransport + factory + transport;

      const toPercent = (value) =>
        total === 0 ? 0 : ((value / total) * 100).toFixed(2);

      return [
        { label: 'โรงงาน และ ขนส่ง', value: toPercent(factoryTransport), color: '#8200db' },
        { label: 'โรงงาน', value: toPercent(factory), color: '#432dd7' },
        { label: 'ขนส่ง', value: toPercent(transport), color: '#a65f00' }
      ];
    },
    legendData2(){
      const carCompany = Number(
        this.incomeSumBusinessFunction(this.sheetFilter?.filter((item)=>item.company_3rd == 'บริษัทรถ')) || 0
      );

      const inCarCompany = Number(
        this.incomeSumBusinessFunction(this.sheetFilter?.filter((item)=>item.company_3rd == 'บริษัทรถร่วม')) || 0
      );

      const total = carCompany + inCarCompany;

      const toPercent = (value) =>
        total === 0 ? 0 : ((value / total) * 100).toFixed(2);

      return [
        { label: 'รถบริษัท', value: toPercent(carCompany), color: '#F97316' },
        { label: 'รถร่วม', value: toPercent(inCarCompany), color: '#06B6D4' },
      ];
    },
    bookingCount() {
      return (this.sheetFilter || []).filter(({ booking_cars, sheet_status })=>([5,15,20,21].includes(booking_cars[0]?.status))&& sheet_status == 4).length;
    },
    incomeSum(){
      return (this.sheetFilter || [])
        .filter(({ booking_cars }) => [20].includes(booking_cars[0]?.status))
        .reduce((a, b) => a + (Math.round(Number(b.total_selling)) || 0), 0).toLocaleString();
    },
    outcomeSum() {
      return(this.sheetFilter || [])
        .filter(({ booking_cars }) => [20].includes(booking_cars[0]?.status))
        .reduce((a, b) => a + (Math.round(this.sum_car_expense(b, b.booking_cars)) || 0), 0).toLocaleString();
    },
    waitingForInvoice() {
      return (this.sheetFilter || [])  
        .filter(({ booking_cars }) => [20].includes(booking_cars[0]?.status))
        .reduce((a, b) => a + (Math.round(Number(b.billings?.find((item)=>item.billing_action_id == 2 && item.billing_status_id != 7)?.total_price)) || 0), 0).toLocaleString();
    },
    formatDate() {
      if(this.activePeriod == 'รายวัน') {
        return 'DD/MM/YYYY';
      } else if(this.activePeriod == 'รายเดือน') {
        return 'MM/YYYY';
      } else if(this.activePeriod == 'รายปี') {
        return 'YYYY';
      }
    },
    datePickerType() {
      if (this.formatDate === 'DD/MM/YYYY') return 'date';
      if (this.formatDate === 'MM/YYYY') return 'month';
      if (this.formatDate === 'YYYY') return 'year';
      return 'date';
    },
  },
  data() {
    return {
      socketService,
      activePeriod: 'รายวัน',
      activeChartPeriod: 'รายวัน',
      activeCarCom: 'ทั้งหมด',
      activeBusiness: 'ทั้งหมด',
      businessTypeId: null,
      carCompanyList: [],
      chart_keys: [
        "income_outcome",
        "business_income",
        "cartype_income",
        "most_used_cars",
        "quotation_summary",
        "booking_status_summary",
        "bookings_summary",
        "sale_summary",
        "fuel_summary",
        "repair_summary",
      ],
      dashboard: [],
      chart_elements: [],
      selectedView: 'operation',
      selectedDate: [dayjs(),dayjs()],
      currentDate: dayjs(),
      sheetFetch: [],
      onlineDrivers: [],
      isChartBuilding: false,
      columnsTripVehicle: [
        {
          title: 'ทะเบียนรถ',
          dataIndex: 'plate_no',
          key: 'plate_no',
          align: 'center'
        },
        {
          title: 'เที่ยว',
          dataIndex: 'work',
          key: 'work',
          align: 'center'
        },
        {
          title: 'ระยะทาง',
          dataIndex: 'distance',
          key: 'distance',
          align: 'center'
        },
        {
          title: 'รายได้',
          dataIndex: 'income',
          key: 'income',
          align: 'center'
        },
      ],
      columnsTripDriver: [
        {
          title: 'ชื่อคนขับ',
          dataIndex: 'driver',
          key: 'driver',
          align: 'center'
        },
        {
          title: 'เที่ยว',
          dataIndex: 'work',
          key: 'work',
          align: 'center'
        },
        {
          title: 'ชั่วโมง',
          dataIndex: 'hour',
          key: 'hour',
          align: 'center'
        },
        {
          title: 'รายได้',
          dataIndex: 'income',
          key: 'income',
          align: 'center'
        },
      ],
      columnsTripSheet: [
        {
          title: 'ทะเบียนรถ',
          dataIndex: 'plate_no',
          key: 'plate_no',
          align: 'center'
        },
        {
          title: 'เลขใบงาน',
          dataIndex: 'booking_no',
          key: 'booking_no',
          align: 'center'
        },
        {
          title: 'ประเภท',
          dataIndex: 'business_type',
          key: 'business_type',
          align: 'center'
        },
        {
          title: 'ต้นทาง',
          dataIndex: 'origin',
          key: 'origin',
          align: 'center'
        },
        {
          title: 'ปลายทาง',
          dataIndex: 'destination',
          key: 'destination',
          align: 'center'
        },
        {
          title: 'คนขับ',
          dataIndex: 'driver',
          key: 'driver',
          align: 'center'
        },
        {
          title: 'สถานะ',
          dataIndex: 'status',
          key: 'status',
          align: 'center'
        },
      ],
      columnsMostTrip: [
        {
          title: 'อันดับ',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
        },
        {
          title: 'ทะเบียน',
          dataIndex: 'plate_no',
          key: 'plate_no',
          align: 'center',
        },
        {
          title: 'งาน',
          dataIndex: 'work',
          key: 'work',
          align: 'center',
        },
        {
          title: 'รวมชม.',
          dataIndex: 'hours',
          key: 'hours',
          align: 'center',
        },
        {
          title: 'รายได้',
          dataIndex: 'income',
          key: 'income',
          align: 'center',
        },
        {
          title: 'น้ำมัน',
          dataIndex: 'gas_cost',
          key: 'gas_cost',
          align: 'center',
        },
        {
          title: 'ซ่อมบำรุง',
          dataIndex: 'repair_cost',
          key: 'repair_cost',
          align: 'center',
        },
        {
          title: 'รวมจ่าย',
          dataIndex: 'total_cost',
          key: 'total_cost',
          align: 'center',
        },
        {
          title: 'กำไร',
          dataIndex: 'benefit',
          key: 'benefit',
          align: 'center',
        },
        {
          title: 'อัตราต้นทุนรถ (%)',
          dataIndex: 'marginCar',
          key: 'marginCar',
          align: 'center',
        },
        {
          title: 'อัตรากำไรของรถ (%)',
          dataIndex: 'marginIncome',
          key: 'marginIncome',
          align: 'center',
        },
      ],
      columnsCheckInDriver: [
        {
          title: 'ลำดับ',
          dataIndex: 'index',
          key: 'index',
          align: 'center'
        },
        {
          title: 'ชื่อคนขับ',
          dataIndex: 'driver',
          key: 'driver',
          align: 'center'
        },
        {
          title: 'ทะเบียนรถ',
          dataIndex: 'plate_no',
          key: 'plate_no',
          align: 'center'
        },
        {
          title: 'เวลาเข้างาน',
          dataIndex: 'time',
          key: 'time',
          align: 'center'
        },
        {
          title: 'เวลาออกงาน',
          dataIndex: 'time_out',
          key: 'time_out',
          align: 'center'
        },
        {
          title: 'ตำแหน่ง GPS',
          dataIndex: 'gps',
          key: 'gps',
          align: 'center'
        },
        {
          title: 'ระยะห่าง (กม.)',
          dataIndex: 'distance',
          key: 'distance',
          align: 'center'
        },
        {
          title: 'สถานะ',
          dataIndex: 'status',
          key: 'status',
          align: 'center'
        },
        {
          title: 'หมายเหตุ',
          dataIndex: 'remark',
          key: 'remark',
          align: 'center'
        },
      ],
      columnsCheckInOffice: [
        {
          title: 'ลำดับ',
          dataIndex: 'index',
          key: 'index',
          align: 'center'
        },
        {
          title: 'ชื่อพนักงาน',
          dataIndex: 'employee',
          key: 'employee',
          align: 'center'
        },
        {
          title: 'ตำแหน่ง',
          dataIndex: 'position',
          key: 'position',
          align: 'center'
        },
        {
          title: 'เวลาเข้างาน',
          dataIndex: 'time',
          key: 'time',
          align: 'center'
        },
        {
          title: 'เวลาออกงาน',
          dataIndex: 'time_out',
          key: 'time_out',
          align: 'center'
        },
        {
          title: 'ตำแหน่ง GPS',
          dataIndex: 'gps',
          key: 'gps',
          align: 'center'
        },
        {
          title: 'ระยะห่าง (กม.)',
          dataIndex: 'distance',
          key: 'distance',
          align: 'center'
        },
        {
          title: 'สถานะ',
          dataIndex: 'status',
          key: 'status',
          align: 'center'
        },
        {
          title: 'หมายเหตุ',
          dataIndex: 'remark',
          key: 'remark',
          align: 'center'
        },
      ],
      paginatedDataTripVehicle: [],
      paginatedDataTopFiveVehicle:[],
      paginatedDataSumDriver: [],
      paginatedDataSumEmp: [],
      paginatedDataTripDriver: [],
      dataSourceTripVehicle: [],
      dataSourceTripDriver: [],
      dataSumDriver: [],
      dataSumEmployee: [],
      paginatedDataWorking: [],
      work_status:[],
      dataWorking: [],
      loadingTripVehicle: false,
      loadingTripDriver: false,
      loadingTripSheet: false,
      loadingMostTrip: false,
      loadingCheckInDriver: false,
      loadingCheckInOffice: false,
      modalVisible: false,
      modalTitle: '',
      modalSubtitle: '',
      modalFooter: null,
      modalTypeData: '',
      modalColumns: [],
      modalLoading: false,
      dataSourceSumDriver:[],
      dataSourceSumUser:[],
      mockChartData2: {
        รายวัน: {
          labels: ['โรงงาน', 'โรงงาน+ขนส่ง', 'ขนส่ง'],
          datasets: [
            {
              label: 'รายได้',
              data: [120000, 85000, 45000],
              backgroundColor: [
                '#432dd7', // โรงงาน
                '#8200db',  // โรงงาน+ขนส่ง
                '#a65f00' // ขนส่ง
              ],
              hoverBackgroundColor: [
                '#432dd7',
                '#8200db',
                '#a65f00'
              ]
            }
          ]
        },

        รายเดือน: {
          labels: ['โรงงาน', 'โรงงาน+ขนส่ง', 'ขนส่ง'],
          datasets: [
            {
              label: 'รายได้',
              data: [3200000, 2100000, 1300000],
              backgroundColor: [
                '#432dd7', // โรงงาน
                '#8200db',  // โรงงาน+ขนส่ง
                '#a65f00'
              ],
              hoverBackgroundColor: [
                '#432dd7',
                '#8200db',
                '#a65f00'
              ]
            }
          ]
        },

        รายปี: {
          labels: ['โรงงาน', 'โรงงาน+ขนส่ง', 'ขนส่ง'],
          datasets: [
            {
              label: 'รายได้',
              data: [38500000, 27200000, 16800000],
              backgroundColor: [
                '#432dd7', // โรงงาน
                '#8200db',  // โรงงาน+ขนส่ง
                '#a65f00'
              ],
              hoverBackgroundColor: [
                '#432dd7',
                '#8200db',
                '#a65f00'
              ]
            }
          ]
        }
      },
      mockChartData3: {
        รายวัน: {
          labels: ['รถบริษัท', 'รถร่วม'],
          datasets: [
            {
              label: 'รายได้',
              data: [120000, 85000],
              backgroundColor: [
                '#F97316',
                '#06B6D4'
              ],
              hoverBackgroundColor: [
                '#F97316',
                '#06B6D4'
              ]
            }
          ]
        },

        รายเดือน: {
          labels: ['รถบริษัท', 'รถร่วม'],
          datasets: [
            {
              label: 'รายได้',
              data: [3200000, 2100000],
              backgroundColor: [
                '#F97316',
                '#06B6D4'
              ],
              hoverBackgroundColor: [
                '#F97316',
                '#06B6D4'
              ]
            }
          ]
        },

        รายปี: {
          labels: ['รถบริษัท', 'รถร่วม'],
          datasets: [
            {
              label: 'รายได้',
              data: [38500000, 27200000],
              backgroundColor: [
                '#F97316',
                '#06B6D4'
              ],
              hoverBackgroundColor: [
                '#F97316',
                '#06B6D4'
              ]
            }
          ]
        }
      },
    };
  },
  methods: {
    printCheck(data){
      console.log("Trippi",data);
    },
    connectSocket() {
        this.socketService.connect();
        this.socketService.joinRoom('dashboard');
        this.socketService.joinRoom('booking');
        this.socketService.onBroadcast((message) => {
          console.log("Socket message received");
          this.loadPage();
          this.updateChart();
          // this.drivers = this.isDriverLeave(message);
        },'dashboard');
        this.socketService.onBroadcast((message) => {
          console.log("Socket message received");
          this.loadPage();
          this.updateChart();
          // this.drivers = this.isDriverLeave(message);
        },'booking');
          
    },
    leaveRoom(channelId) {
      this.socketService.leaveRoom(channelId);
      this.socketService.offBroadcast(channelId);
    },
    getDistanceInKm(lat1, lng1, lat2, lng2) {
      const toRad = (value) => (value * Math.PI) / 180;

      const R = 6371;

      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
          Math.cos(toRad(lat2)) *
          Math.sin(dLng / 2) *
          Math.sin(dLng / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return R * c;
    },
    distanceText(distance){
      if(distance >= 1){
        return distance + 'km'
      }
      return distance ? Math.round(Number(distance)*1000) + 'm' : '-'
    },
    async export_file(data,modalType) {
      this.$message.loading({ content: "กำลังโหลด...", key: "loading" });

      // Define headers for the Excel file
      const headersColumn = modalType == 'checkin_office' 
        ? [
            {
              header: 'ลำดับ',
              key: 'index',
            },
            {
              header: 'ชื่อพนักงาน',
              key: 'employee',
            },
            {
              header: 'ตำแหน่ง',
              key: 'position',
            },
            {
              header: 'เวลาเข้างาน',
              key: 'time',
            },
            {
              header: 'เวลาออกงาน',
              key: 'time_out',
            },
            {
              header: 'ตำแหน่ง GPS',
              key: 'gps',
            },
            {
              header: 'ระยะห่าง (กม.)',
              key: 'distance',
            },
            {
              header: 'สถานะ',
              key: 'status',
            },
            {
              header: 'หมายเหตุ',
              key: 'remark',
            },
          ] 
        : [
            {
              header: 'ลำดับ',
              key: 'index',
            },
            {
              header: 'ชื่อคนขับ',
              key: 'driver',
            },
            {
              header: 'ทะเบียนรถ',
              key: 'plate_no',
            },
            {
              header: 'เวลาเข้างาน',
              key: 'time',
            },
            {
              header: 'เวลาออกงาน',
              key: 'time_out',
            },
            {
              header: 'ตำแหน่ง GPS',
              key: 'gps',
            },
            {
              header: 'ระยะห่าง (กม.)',
              key: 'distance',
            },
            {
              header: 'สถานะ',
              key: 'status',
            },
            {
              header: 'หมายเหตุ',
              key: 'remark',
            },
          ];
      var dataExport = []
      if(modalType == 'checkin_driver'){
        dataExport = data.map((item, index) => ({
          index: item.index,
          driver: item.driver,
          plate_no: item.plate_no,
          time: item.time,
          time_out: item.time_out,
          gps:  (item?.gps ?? '-') + (item?.gps_out ? '\n' + item.gps_out : '') ,
          distance: this.distanceText(item.distance) + (item?.distance_out ? '\n' + this.distanceText(item.distance_out) : ''),
          status: item.status,
          remark: item.remark,
        }));
      }else{
        dataExport = data.map((item, index) => ({
          index: item.index,
          employee: item.employee,
          position: item.position,
          time: item.time,
          time_out: item.time_out,
          gps: (item?.gps ?? '-') + (item?.gps_out ? '\n' + item.gps_out : '' ),
          distance: this.distanceText(item.distance) + (item?.distance_out ? '\n' + this.distanceText(item.distance_out) : ''),
          status: item.status,
          remark: item.time ? ('เช็คอิน :' + (item?.remark ? 'นอกรัศมีที่กำหนด' : '-')) +'\n'+ (item?.time_out ? 'เช็คเอาต์ :' + (item.remark_out ? 'นอกรัศมีที่กำหนด' : '-') : '') : '',
        }));
      }
      const workBook = XLSX.utils.book_new();
      const workSheet = XLSX.utils.json_to_sheet(dataExport, [headersColumn.map(h => h.header)]);

      XLSX.utils.sheet_add_aoa(workSheet, [headersColumn.map((h) => h.header)], { origin: "A1" });

      Object.keys(workSheet).forEach((cell) => {
        if (!cell.startsWith('!')) {
          if (!workSheet[cell].s) workSheet[cell].s = {};
          workSheet[cell].s.alignment = { wrapText: true, vertical: "center" };
        }
      });
      headersColumn.forEach((header, index) => {
          const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
          let cell = workSheet[cellAddress];
          if (!cell) {
              cell = { v: "" };
              workSheet[cellAddress] = cell;
          }

          const bgColor = "#f0b474";  

          cell.s = {
              font: { bold: true },
              fill: { fgColor: { rgb: bgColor.replace("#", "") } },
              border: {
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                  left: { style: "thin" },
                  top: { style: "thin" },
              },
              alignment: { horizontal: "center", vertical: "center" , wrapText: true},
          };
      });


      workSheet['!cols'] = headersColumn.map(() => ({ wch: 25 }));

      XLSX.utils.book_append_sheet(workBook, workSheet, "Report");

      XLSX.writeFile(workBook, `${modalType}.xlsx`);
      this.$message.success({ content: "สร้างไฟล์สำเร็จ", key: "loading" });
    },
    getRandomColor(alpha = 0.7) {
      const r = Math.floor(Math.random() * 200);
      const g = Math.floor(Math.random() * 200);
      const b = Math.floor(Math.random() * 200);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    isHexColor(color) {
      return /^#[0-9A-Fa-f]{6}$/.test(color);
    },
    statusStyle(color) {
        const opacityBackground = this.hexToRgba(color, 0.3);
        const opacityBorder = this.hexToRgba(color, 0.5);
        return `border: 1px solid ${opacityBorder}; 
                background-color: ${opacityBackground}; 
                color: ${color};
                display: inline-block;
                padding: 0px 7px;
                width: 'fit-content';
                border-radius: 2px;
                font-size: 12px;`;
    },
    statusBusinessStyle(color) {
      const background = this.lightenColor(color, 0.94); // 90% lighter
      const border = this.lightenColor(color, 0.6);     // 60% lighter
      return `
          border: 1px solid ${border};
          background-color: ${background};
          color: ${color};
          border-radius: 12px;
          height: 100%;
      `;
    },
    lightenColor(hex, percent) {
        let r = parseInt(hex.substring(1, 3), 16);
        let g = parseInt(hex.substring(3, 5), 16);
        let b = parseInt(hex.substring(5, 7), 16);

        r = Math.round(r + (255 - r) * percent);
        g = Math.round(g + (255 - g) * percent);
        b = Math.round(b + (255 - b) * percent);

        return `rgb(${r}, ${g}, ${b})`;
    },
    hexToRgba(hex, alpha) {
      let r = parseInt(hex.substring(1, 3), 16);
      let g = parseInt(hex.substring(3, 5), 16);
      let b = parseInt(hex.substring(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    formatThaiDate(date) {
      if (!date) return '';

      const days = [
        'วันอาทิตย์','วันจันทร์','วันอังคาร','วันพุธ',
        'วันพฤหัสบดี','วันศุกร์','วันเสาร์'
      ];

      const months = [
        'มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน',
        'กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'
      ];

      const d = new Date(date);
      const dayName = days[d.getDay()];
      const day = d.getDate();
      const month = months[d.getMonth()];
      const year = d.getFullYear() + 543;

      return `${dayName}ที่ ${day} ${month} ${year}`;
    },
    statusBusiness(record){
      if (record == 1) {
        return { txt: "โรงงาน", color: "#1d39c4" };
      }
      else if (record == 2) {
        return { txt: "ขนส่ง", color: "#a65f00" };
      }
      else if (record == 3) {
        return { txt: "โรงงาน และ ขนส่ง", color: "#531dab" };
      }
      else if(record == 4){
        return { txt: "ทั้งหมด", color: "#389e0d" };
      }
      else{
        return { txt: "ไม่มีข้อมูล", color: "#B3B3B3" }
      }
    },
    statusCar(record){
      if(this.businessTypeId == 3) {
        if (record.status == 15) {
          return { txt: "รอตรวจสอบ", color: "#EA580C" };
        }
        if (record.status == 20) {
          return { txt: "ตรวจสอบแล้ว", color: "#065F46" };
        }
        if (record.status == null) {
          return { txt: "ทั้งหมด", color: "#1E3A8A" };
        }
        if (record.status == 0) {
          return { txt: "แนะนำการจัดรถ", color: "blue" };
        }
        if (record.status == 1) {
          return { txt: "ทั้งหมด", color: "#1E3A8A"};
        }
        if (record.status == 2) {
          return { txt: "จัดรถแล้ว", color: "#A7F3D0" };
        }
        if (record.status == 3) {
          return { txt: "ถึงจุดรับรถแล้ว", color: "green" };
        }
        if (record.status == 4  && this.userBusinessId == 4) {
          return { txt: "ส่งลูกค้าแล้วเสร็จ", color: "blue" };
        }
        if (record.status == 5 && this.userBusinessId == 4) {
          return { txt: "จบงาน", color: "#686A6D" };
        }
        if (record.status == 5 && this.userBusinessId != 4) {
          return { txt: "จบงาน", color: "#D1D5DB" };
        }
        if (record.status == 6) {
          return { txt: "ยกเลิกการเดินทาง", color: "#B91C1C" };
        }
        if (record.status == 7) {
          return { txt: "กำลังเดินทาง", color: "blue" };
        }
        if (record.status == 8) {
          return { txt: "รับงาน", color: "#10B981" };
        }
        if (record.status == 9 && this.userBusinessId != 4) {
          return { txt: "รถออกจากลานจอด", color: "#8B4513" };
        }
        if (record.status == 9 && this.userBusinessId == 4) {
          return { txt: "เริ่มงาน", color: "purple" };
        }
        if (record.status == 10 && this.userBusinessId != 4) {
          return { txt: "กำลังขึ้นของ", color: "#FBBF24" };
        }
        if (record.status == 10 && this.userBusinessId == 4) {
          return { txt: "รับลูกค้าขึ้นยานพาหนะ", color: "orange" };
        }
        if (record.status == 11) {
          return { txt: "แจ้งงาน", color: "orange" };
        }
        if (record.status == 12) {
          return { txt: "รับของ", color: "blue" };
        }
        if (record.status == 13) {
          return { txt: "รับของเสร็จสิ้น", color: "orange" };
        }
        if (record.status == 14) {
          return { txt: "ปฏิเสธงาน", color: "#DC2626" };
        }
        if (record.status == 15) {
          return { txt: "ตรวจสอบ", color: "orange" };
        }
        if (record.status == 16) {
          return { txt: "รถถึงต้นทาง", color: "#6D28D9" };
        }
        if (record.status == 17) {
          return { txt: "อยู่ระหว่างขนส่ง", color: "#93C5FD" };
        }
        if (record.status == 18) {
          return { txt: "กำลังลงของ", color: "#FFD700" };
        }
        if (record.status == 19) {
          return { txt: "รถถึงปลายทาง", color: "#2563EB" };
        }
        if (record.status == 20) {
          return { txt: "ตรวจสอบแล้ว", color: "#065F46" };
        }
      } else {
        if (record.status == 15) {
          return { txt: "รอตรวจสอบ", color: "orange" };
        }
        if (record.status == 20) {
          return { txt: "ตรวจสอบแล้ว", color: "orange" };
        }
        if (record.status == null) {
          return { txt: "ทั้งหมด" };
        }
        if (record.status == 0) {
          return { txt: "แนะนำการจัดรถ", color: "blue" };
        }
        if (record.status == 1) {
          return { txt: "ทั้งหมด"};
        }
        if (record.status == 2) {
          return { txt: "จัดรถแล้ว", color: "green" };
        }
        if (record.status == 3) {
          return { txt: "ถึงจุดรับรถแล้ว", color: "green" };
        }
        if (record.status == 4  && this.userBusinessId == 4) {
          return { txt: "ส่งลูกค้าแล้วเสร็จ", color: "blue" };
        }
        if (record.status == 5 && this.userBusinessId == 4) {
          return { txt: "จบงาน", color: "#686A6D" };
        }
        if (record.status == 5 && this.userBusinessId != 4) {
          return { txt: "จบงาน", color: "green" };
        }
        if (record.status == 6) {
          return { txt: "ยกเลิกการเดินทาง", color: "red" };
        }
        if (record.status == 7) {
          return { txt: "กำลังเดินทาง", color: "blue" };
        }
        if (record.status == 8) {
          return { txt: "รับงาน", color: "green" };
        }
        if (record.status == 9 && this.userBusinessId != 4) {
          return { txt: "รถออกจากลานจอด", color: "green" };
        }
        if (record.status == 9 && this.userBusinessId == 4) {
          return { txt: "เริ่มงาน", color: "purple" };
        }
        if (record.status == 10 && this.userBusinessId != 4) {
          return { txt: "กำลังขึ้นของ", color: "orange" };
        }
        if (record.status == 10 && this.userBusinessId == 4) {
          return { txt: "รับลูกค้าขึ้นยานพาหนะ", color: "orange" };
        }
        if (record.status == 11) {
          return { txt: "แจ้งงาน", color: "orange" };
        }
        if (record.status == 12) {
          return { txt: "รับของ", color: "blue" };
        }
        if (record.status == 13) {
          return { txt: "รับของเสร็จสิ้น", color: "orange" };
        }
        if (record.status == 14) {
          return { txt: "ปฏิเสธงาน", color: "red" };
        }
        if (record.status == 15) {
          return { txt: "ตรวจสอบ", color: "orange" };
        }
        if (record.status == 16) {
          return { txt: "รถถึงต้นทาง", color: "purple" };
        }
        if (record.status == 17) {
          return { txt: "อยู่ระหว่างขนส่ง", color: "pink" };
        }
        if (record.status == 18) {
          return { txt: "กำลังลงของ", color: "yellow" };
        }
        if (record.status == 19) {
          return { txt: "รถถึงปลายทาง", color: "blue" };
        }
        if (record.status == 20) {
          return { txt: "ตรวจสอบแล้ว", color: "green" };
        }
      }
    },
    countFunction(array) {
      return array?.filter((item)=>item?.sheet_status == 4 && item?.booking_cars?.[0]?.status == 20).length || 0;
    },
    incomeSumFunction(array){
      return array
        ?.filter(({ booking_cars }) => [20].includes(booking_cars[0]?.status))
        ?.reduce((a, b) => a + (Math.round(Number(b.total_selling)) || 0), 0).toLocaleString() || 0;
    },
    outcomeSumFunction(array) {
      return array
        ?.filter(({ booking_cars }) => [20].includes(booking_cars[0]?.status))
        ?.reduce((a, b) => a + (Math.round(this.sum_car_expense(b, b.booking_cars)) || 0), 0).toLocaleString();
    },
    waitingForInvoiceFunction(array) {
      return array
        ?.filter(({ booking_cars }) => [20].includes(booking_cars[0]?.status))
        ?.reduce((a, b) => a + (Math.round(Number(b.billings?.find((item)=>item.billing_action_id == 2 && item.billing_status_id != 7)?.total_price)) || 0), 0).toLocaleString();
    },
    countCar(array){
      const uniqueCarCount = new Set(
        array
          ?.filter(({ booking_cars }) => [20].includes(booking_cars[0]?.status))
          ?.map(item => item.booking_cars?.[0]?.car?.plate_no)
          ?.filter(Boolean)
      ).size
      return uniqueCarCount || 0
    },
    incomeSumBusinessFunction(array) {
      return array
        ?.filter(({ booking_cars }) => [20].includes(booking_cars[0]?.status))
        ?.reduce((a, b) => a + (Math.round(Number(b.total_selling)) || 0), 0)|| 0; // return NUMBER
    },
    async updateChart() {
      // Income vs Expense Chart
      await this.fetchDataUserDashboard();
      await this.fetchDataDriverDashboard();
      await this.fetchDataWorkingDashboard();
      await this.fetchDataTripVehicle();
      await this.fetchDataTripDriver();
      let chartData
      if (this.activeChartPeriod === 'รายวัน') {
        chartData = this.buildDailyChart();
      } else if (this.activeChartPeriod === 'รายเดือน') {
        chartData = this.buildMonthlyChart();
      } else {
        chartData = this.buildYearlyChart();
      }
      if (!chartData) return;

      const { labels, income, expense } = chartData;
      const datasets = [
        {
          label: 'รายได้',
          data: income,
          backgroundColor: '#f97316',
          tension: 0.4,
        },
        {
          label: 'รายจ่าย',
          data: expense,
          backgroundColor: '#10b981',
          tension: 0.4,
        },
      ];
      this.dashboard.income_outcome = {data: {}, options: {}, type: 'bar'};
      this.dashboard.income_outcome.options = {
        responsive: true,
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                const label = context.dataset.label || '';
                const value = context.raw;
                return `${label}: ${Number(value).toLocaleString()} บาท`;
              }
            }
          }
        }
      };

      this.dashboard.income_outcome.data.labels = labels;
      this.dashboard.income_outcome.data.datasets = datasets;
      // if(this.selectedView == 'admin') {
        // Business Income Chart        
        const chartData2 = {
          labels: ['โรงงาน', 'โรงงาน+ขนส่ง', 'ขนส่ง'],
          datasets: [
            {
              label: 'รายได้',
              data: [ this.incomeSumBusinessFunction(this.sheetFilter?.filter((item)=>item.booking_business_type_id == 1)), 
                      this.incomeSumBusinessFunction(this.sheetFilter?.filter((item)=>item.booking_business_type_id == 3)), 
                      this.incomeSumBusinessFunction(this.sheetFilter?.filter((item)=>item.booking_business_type_id == 2))],
              backgroundColor: [
                '#432dd7', // โรงงาน
                '#8200db',  // โรงงาน+ขนส่ง
                '#a65f00' // ขนส่ง
              ],
              hoverBackgroundColor: [
                '#432dd7',
                '#8200db',
                '#a65f00'
              ]
            }
          ]
        }
        const { labels: labels2, datasets: datasets2  } = chartData2;
        this.dashboard.business_income = {data: {}, options: {}, type: 'pie'};
        this.dashboard.business_income.options = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const label = context.label || '';
                  const total = context.dataset.data.reduce((sum, val) => sum + val, 0);
                  const value = (context.raw/total * 100).toFixed(2);
                  return `${label}: ${Number(value).toLocaleString()}%`;
                }
              }
            }
          }
        };

        this.dashboard.business_income.data.labels = labels2;
        this.dashboard.business_income.data.datasets = datasets2;

        const chartData3 = {
          labels: ['รถบริษัท', 'รถร่วม'],
          datasets: [
            {
              label: 'รายได้',
              data: [ this.incomeSumBusinessFunction(this.sheetFilter?.filter((item)=>item.company_3rd == 'บริษัทรถ'))
                ,this.incomeSumBusinessFunction(this.sheetFilter?.filter((item)=>item.company_3rd == 'บริษัทรถร่วม'))],
              backgroundColor: [
                '#F97316',
                '#06B6D4'
              ],
              hoverBackgroundColor: [
                '#F97316',
                '#06B6D4'
              ]
            }
          ]
        }
        const { labels: labels3, datasets: datasets3  } = chartData3;
        this.dashboard.cartype_income = {data: {}, options: {}, type: 'pie'};
        this.dashboard.cartype_income.options = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const label = context.label || '';
                  const total = context.dataset.data.reduce((sum, val) => sum + val, 0);
                  const value = (context.raw/total * 100).toFixed(2);
                  return `${label}: ${Number(value).toLocaleString()}%`;
                }
              }
            }
          }
        };

        this.dashboard.cartype_income.data.labels = labels3;
        this.dashboard.cartype_income.data.datasets = datasets3;
      // }
      this.create_charts(this.dashboard);
    },
    async init_charts(key) {
      console.debug('[init_charts] key=', key, ' $refs[key]=', this.$refs[key]);
      // ค้นหา chart ที่มี key ตรงกันใน chart_elements
      const chartIndex = this.chart_elements.findIndex((el) => el.key === key); 
      // ถ้า chart เก่ามีอยู่ ให้ทำลาย chart เก่า
      if (chartIndex !== -1) {
        this.chart_elements[chartIndex].chart.destroy();
        this.chart_elements.splice(chartIndex, 1);
      }

      // Resolve the actual HTMLCanvasElement from this.$refs[key].
      let raw = this.$refs[key];
      let canvas = null;

      // If ref is an array (multiple elements), try to find a canvas element
      if (Array.isArray(raw)) {
        for (const r of raw) {
          if (!r) continue;
          if (r instanceof HTMLCanvasElement) { canvas = r; break; }
          if (r.$el) {
            const found = r.$el.tagName === 'CANVAS' ? r.$el : r.$el.querySelector('canvas');
            if (found) { canvas = found; break; }
          }
        }
      } else if (raw) {
        if (raw instanceof HTMLCanvasElement) {
          canvas = raw;
        } else if (raw.$el) {
          canvas = raw.$el.tagName === 'CANVAS' ? raw.$el : raw.$el.querySelector('canvas');
        }
      }

      if (!canvas || (typeof canvas.isConnected !== 'undefined' && !canvas.isConnected)) {
        console.error(`Failed to create chart: can't find mounted canvas for ref '${key}'`);
        return;
      }

      const context = canvas?.getContext?.('2d');
      if (!context) {
        console.error(`Failed to create chart: can't acquire 2D context from the canvas with ref '${key}'`);
        return;
      }

      // ดึงข้อมูล chart ใหม่จาก key
      const { type, options, data } = this[key];
      const config = {
        type: type,
        data: data,
        options: options,
      };

      // สร้าง chart ใหม่และเพิ่มเข้าไปใน chart_elements
      const newChart = new Chart(context, config);
      this.chart_elements.push({ key, chart: newChart });
    },
    async create_charts(dashboard) {
      this.isChartBuilding = true;
      try {
        await this.$nextTick();

        for (const key in dashboard) {
          if (!dashboard.hasOwnProperty(key)) continue;

          this[key] = dashboard[key];

          if (!this.chart_keys.includes(key)) continue;

          // if (
          //   (key === 'business_income' || key === 'cartype_income') &&
          //   this.selectedView !== 'admin'
          // ) {
          //   continue;
          // }

          await this.$nextTick();
          try {
            await this.init_charts(key);
          } catch (err) {
            console.error(`[create_charts] init_charts failed for key='${key}':`, err);
          }
        }
      } finally {
        setTimeout(() => {
          this.isChartBuilding = false;
        }, 2500);
      }
    },
    sum_car_expense(record, booking_cars) {
      if (!record || !booking_cars) {
        console.warn("sum_car_expense() received null record or booking_cars:", record, booking_cars);
        return 0;
      }
      let expensesSum = booking_cars
        .map(({ expenses }) => 
          Array.isArray(expenses)
            ? expenses.reduce((a, b) => a + (b.granted === 1 ? Number(b.total_payment) : 0), 0)
            : 0
        )
        .reduce((a, b) => a + b, 0);
      
      if (record?.company_3rd === 'บริษัทรถร่วม') {
        const priceCar = Number(record?.price_car) || 0;
        const liftThings = Number(record?.lift_things) || 0;
        return Number(priceCar) + Number(liftThings) + Number(expensesSum);
      }

      let otherCosts = booking_cars
        .map(({ toll_ways, gas_refills }) => {
          const tollWaysSum = Array.isArray(toll_ways)
            ? toll_ways.reduce((a, b) => a + (b.granted === 1 ? Number(b.paid_amount || 0) : 0), 0)
            : 0;
          const gasRefillsSum = Array.isArray(gas_refills)
            ? gas_refills.reduce((a, b) => a + (b.granted === 1 ? Number(b.total_amount || 0) : 0), 0)
            : 0;
          return tollWaysSum + gasRefillsSum;
        })
        .reduce((a, b) => a + b, 0);

      const driverCost = booking_cars
        .map(({ driver }) => driver ? Number(driver.salary) / 26 : 0)
        .reduce((a, b) => a + b, 0);

      const rentalPrice = (record?.price_car && Number(record?.price_car) != 0) 
        ? Number(record?.price_car) 
        : booking_cars
        .map(({ car }) => car ? Number(car.car_payment) / 26 : 0)
        .reduce((a, b) => a + b, 0);
      return otherCosts + expensesSum + driverCost + rentalPrice;
    },
    getIncome(sheet) {
      return Math.round(Number(sheet.total_selling)) || 0;
    },

    getExpense(sheet) {
      return Math.round(this.sum_car_expense(sheet, sheet.booking_cars)) || 0;
    },
    getDaysInMonth() {
      const days = this.selectedDate?.[1].daysInMonth();
      return Array.from({ length: days }, (_, i) => i + 1);
    },
    buildDailyChart() {
      const sheetDaily = this.sheetFetch?.filter((item)=> dayjs(item.time_start).format('YYYY/MM') >= this.selectedDate?.[0].format("YYYY/MM")
                        &&  dayjs(item.time_start).format('YYYY/MM') <= this.selectedDate?.[1].format("YYYY/MM") 
                        && item.booking_cars[0]?.status == 20 );

      const days = this.getDaysInMonth();

      const incomeMap = {};
      const expenseMap = {};

      days?.forEach(d => {
        incomeMap[d] = 0;
        expenseMap[d] = 0;
      });

      sheetDaily?.forEach(sheet => {
        const day = dayjs(sheet.time_start).date();
        incomeMap[day] += this.getIncome(sheet);
        expenseMap[day] += this.getExpense(sheet);
      });

      return {
        labels: days,
        income: days.map(d => incomeMap[d]),
        expense: days.map(d => expenseMap[d]),
      };
    },
    buildMonthlyChart() {
      const sheetMonthly = this.sheetFetch?.filter((item)=> dayjs(item.time_start).format('YYYY') >= this.selectedDate?.[0].format("YYYY")
                          &&  dayjs(item.time_start).format('YYYY') <= this.selectedDate?.[1].format("YYYY") 
                          && item.booking_cars[0]?.status == 20 );
      const labels = [
        'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
        'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
      ];

      const income = Array(12).fill(0);
      const expense = Array(12).fill(0);

      sheetMonthly?.forEach(sheet => {
        const m = dayjs(sheet.time_start).month(); // 0–11
        income[m] += this.getIncome(sheet);
        expense[m] += this.getExpense(sheet);
      });

      return { labels, income, expense };
    },
    buildYearlyChart() {
      const map = {};

      this.sheetFetch?.filter((item)=>item.booking_cars[0]?.status == 20 )?.forEach(sheet => {
        const y = dayjs(sheet.time_start).year();
        if (!map[y]) map[y] = { income: 0, expense: 0 };
        map[y].income += this.getIncome(sheet);
        map[y].expense += this.getExpense(sheet);
      });

      const years = Object.keys(map).sort();
      return {
        labels: years,
        income: years.map(y => map[y].income),
        expense: years.map(y => map[y].expense),
      };
    },
    async fetchDataTripVehicle() {
      this.dataSourceTripVehicle = [];
      let useStartDate = this.selectedDate?.[0];
      let useEndDate = this.selectedDate?.[1];
      if(this.activePeriod == 'รายเดือน') {
        useStartDate = this.selectedDate?.[0].startOf('month');
        useEndDate = this.selectedDate?.[1].endOf('month');
      } else if(this.activePeriod == 'รายปี') {
        useStartDate = this.selectedDate?.[0].startOf('year');
        useEndDate = this.selectedDate?.[1].endOf('year');
      }
      const getSumTripVehicle = await UserService.getAllSumTripVehicle(useStartDate?.format("DD/MM/YYYY"),useEndDate?.format("DD/MM/YYYY"));
      let dataSumTripVehicle = getSumTripVehicle;
      let dataTopFiveVehicle = [];
      dataSumTripVehicle?.forEach((item , index)=>{
        const data = {
          index: index + 1,
          plate_no: item.plate_no,
          work: Number(item.work),
          distance: Number(item.distance),
          income: "฿" + Number(item.car_cost || 0).toLocaleString('en-US'),
          company_3rd: item.company_3rd,
          booking_business_type_id: item.booking_business_type_id,
        };
        this.dataSourceTripVehicle.push(data);
        const outcome = Number(item.gas_cost) + Number(item?.repair_cost || 0);
        const benefit = Number(item.car_cost) - outcome;
        const data2 = {
          index: index + 1,
          plate_no: item.plate_no,
          work: Number(item.work),
          income: Number(item.car_cost),
          hours: Number(item.hours),
          gas_cost: Number(item.gas_cost),
          repair_cost: Number(item?.repair_cost || 0),
          total_cost: outcome,
          benefit: benefit,
          marginCar: Number(item.car_cost) > 0 ? Number(outcome/Number(item.car_cost) * 100).toFixed(2) : 0,
          marginIncome: Number(item.car_cost) > 0 ? Number(benefit/Number(item.car_cost) * 100).toFixed(2) : 0,
          company_3rd: item.company_3rd,
          booking_business_type_id: item.booking_business_type_id,
        }
        dataTopFiveVehicle.push(data2);
      }); 
      this.paginatedDataTripVehicle = this.dataSourceTripVehicle;
      this.paginatedDataTopFiveVehicle = dataTopFiveVehicle;
      this.paginatedDataTripVehicle.total = this.dataSourceTripVehicle.length;
    },
    getDriverStatus(driver) {
      if (driver?.leave_type) {
        return this.work_status?.find((item) => item.id == driver?.leave_type)?.name
      }

      if (driver?.check_in_datetime) {
        return 'เข้างาน'
      }else{
        return 'ยังไม่เข้างาน'
      }
      // return driver.work_status_name ?? ''
    },
    async fetchDataDriverDashboard() {
      this.dataSourceSumDriver = [];
      let useStartDate = this.selectedDate?.[0];
      let useEndDate = this.selectedDate?.[1];
      let getDriverDashboard = [];
      if((useStartDate.isSame(useEndDate)) && useStartDate != null && useEndDate != null){
        getDriverDashboard = await UserService.getAllDriverDashboard(useStartDate?.format("DD/MM/YYYY"),useEndDate?.format("DD/MM/YYYY"));
      }else{
        getDriverDashboard = await UserService.getAllDriverDashboard(dayjs()?.format("DD/MM/YYYY"),dayjs()?.format("DD/MM/YYYY"));
      }
      this.dataSumDriver = getDriverDashboard;
      const companyLat = Number(this.carCompanyList?.[0]?.lat ?? 0)
      const companyLng =  Number(this.carCompanyList?.[0]?.lng ?? 0)

      const toRad = deg => deg * Math.PI / 180

      const companyLatRad = toRad(companyLat)
      const companyLngRad = toRad(companyLng)

      const R = 6371

      this.dataSourceSumDriver = this.dataSumDriver.map((driver, index) => {
        let distance = null
        if (
          driver?.check_in_lat != null &&
          driver?.check_in_lng != null &&
          companyLat != null &&
          companyLng != null
        ) {
          const latRad = toRad(driver.check_in_lat)
          const lngRad = toRad(driver.check_in_lng)

          const dLat = latRad - companyLatRad
          const dLng = lngRad - companyLngRad

          const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(companyLatRad) *
            Math.cos(latRad) *
            Math.sin(dLng / 2) ** 2

          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

          distance = (R * c).toFixed(2)
        }
        let distance_out = null
        if (
          driver?.check_out_lat != null &&
          driver?.check_out_lng != null &&
          companyLat != null &&
          companyLng != null
        ) {
          const latRad = toRad(driver.check_out_lat)
          const lngRad = toRad(driver.check_out_lng)

          const dLat = latRad - companyLatRad
          const dLng = lngRad - companyLngRad

          const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(companyLatRad) *
            Math.cos(latRad) *
            Math.sin(dLng / 2) ** 2

          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

          distance_out = (R * c).toFixed(2)
        }
        return {
          driver: driver.firstname + (driver.lastname ? ' ' + driver.lastname : ''),
          plate_no: driver.plate_no ?? '',
          firstname: driver.firstname ?? '',
          lastname: driver.lastname ?? '',
          phone_no: driver.phone_no ?? '',
          work_status_id: driver.work_status_id ?? '',
          status: this.getDriverStatus(driver),
          time: driver.check_in_datetime ? new Date(driver.check_in_datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '',
          time_out: driver.check_out_datetime ? new Date(driver.check_out_datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '',
          check_in_type_id: driver?.check_in_type_id,
          leave_type: driver?.leave_type,
          work_status_today: driver.work_status_today ?? '',
          booking_status: driver?.booking_status,
          booking_waiting: driver?.has_booking_waiting,
          username: driver.username ?? '',
          rating: driver.rating ?? '',
          gps: driver?.check_in_lat != null && driver?.check_in_lng != null
            ? `${Math.abs(driver.check_in_lat)}°${driver.check_in_lat >= 0 ? 'N' : 'S'}, ` +
              `${Math.abs(driver.check_in_lng)}°${driver.check_in_lng >= 0 ? 'E' : 'W'}` 
            : null,
          gps_out: driver?.check_out_lat != null && driver?.check_out_lng != null
            ? `${Math.abs(driver.check_out_lat)}°${driver.check_out_lat >= 0 ? 'N' : 'S'}, ` +
              `${Math.abs(driver.check_out_lng)}°${driver.check_out_lng >= 0 ? 'E' : 'W'}` 
            : null,
          remark: driver.remark ?? '',
          company_3rd: driver.company_3rd,
          distance: (distance ?? '') ,
          distance_out: (distance_out ?? '') ,
          check_in_raw: driver.check_in_datetime ? new Date(driver.check_in_datetime) : null,
        };
      });

      this.paginatedDataSumDriver = [...this.dataSourceSumDriver].sort((a, b) => {
        if (!a.check_in_raw) return 1;
        if (!b.check_in_raw) return -1;

        return a.check_in_raw - b.check_in_raw;
      }).map((item, index) => ({
        ...item,
        index: index + 1,
      }));
      this.paginatedDataSumDriver.total = this.dataSourceSumDriver.length;
    },
    async fetchDataUserDashboard() {
      this.dataSourceSumUser = [];
      let useStartDate = this.selectedDate?.[0];
      let useEndDate = this.selectedDate?.[1];
      let getDriverDashboard = [];
      if((useStartDate.isSame(useEndDate)) && useStartDate != null && useEndDate != null){
        getDriverDashboard = await CheckInHistoryService.getCheckInUserDashboard(useStartDate?.format("DD/MM/YYYY"),useEndDate?.format("DD/MM/YYYY"));
      }else{
        getDriverDashboard = await CheckInHistoryService.getCheckInUserDashboard(dayjs()?.format("DD/MM/YYYY"),dayjs()?.format("DD/MM/YYYY"));
      }
      this.dataSumEmployee = getDriverDashboard;
      const companyLat = Number(this.carCompanyList?.[0]?.lat ?? 0)
      const companyLng =  Number(this.carCompanyList?.[0]?.lng ?? 0)

      const toRad = deg => deg * Math.PI / 180

      const companyLatRad = toRad(companyLat)
      const companyLngRad = toRad(companyLng)

      const R = 6371

      this.dataSourceSumUser = this.dataSumEmployee.map((Emp, index) => {
        let distance = null
        if (
          Emp?.check_in_lat != null &&
          Emp?.check_in_lng != null &&
          companyLat != null &&
          companyLng != null
        ) {
          const latRad = toRad(Emp.check_in_lat)
          const lngRad = toRad(Emp.check_in_lng)

          const dLat = latRad - companyLatRad
          const dLng = lngRad - companyLngRad

          const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(companyLatRad) *
            Math.cos(latRad) *
            Math.sin(dLng / 2) ** 2

          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

          distance = (R * c).toFixed(2)
        }
        let distance_out = null
        if (
          Emp?.check_out_lat != null &&
          Emp?.check_out_lng != null &&
          companyLat != null &&
          companyLng != null
        ) {
          const latRad = toRad(Emp.check_out_lat)
          const lngRad = toRad(Emp.check_out_lng)

          const dLat = latRad - companyLatRad
          const dLng = lngRad - companyLngRad

          const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(companyLatRad) *
            Math.cos(latRad) *
            Math.sin(dLng / 2) ** 2

          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

          distance_out = (R * c).toFixed(2)
        }
        return {
          index: index + 1,
          employee: Emp?.fullname ?? '',
          position: Emp?.position ?? '-',
          status: Emp?.leave_name ? Emp?.leave_name : (Emp?.check_in_datetime) ? 'เข้างาน' : 'ยังไม่เข้างาน',
          time: Emp.check_in_datetime ? new Date(Emp.check_in_datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '',
          time_out: Emp.check_out_datetime ? new Date(Emp.check_out_datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '',
          gps: Emp?.check_in_lat != null && Emp?.check_in_lng != null
            ? `${Math.abs(Emp.check_in_lat)}°${Emp.check_in_lat >= 0 ? 'N' : 'S'}, \n` +
              `${Math.abs(Emp.check_in_lng)}°${Emp.check_in_lng >= 0 ? 'E' : 'W'}`
            : null,
          gps_out: Emp?.check_out_lat != null && Emp?.check_out_lng != null
            ? `${Math.abs(Emp.check_out_lat)}°${Emp.check_out_lat >= 0 ? 'N' : 'S'}, \n` +
              `${Math.abs(Emp.check_out_lng)}°${Emp.check_out_lng >= 0 ? 'E' : 'W'}`
            : null,
          remark: Emp?.check_in_remark,
          remark_out: Emp?.check_out_remark,
          distance: (distance ?? '') ,
          distance_out: (distance_out ?? ''),
          check_in_raw: Emp.check_in_datetime ? new Date(Emp.check_in_datetime) : null,
        };
      });

      this.paginatedDataSumEmp = [...this.dataSourceSumUser].sort((a, b) => {
        if (!a.check_in_raw) return 1;
        if (!b.check_in_raw) return -1;

        return a.check_in_raw - b.check_in_raw;
      }).map((item, index) => ({
        ...item,
        index: index + 1,
      }));
      this.paginatedDataSumEmp.total = this.dataSourceSumUser.length;
    },
    async fetchDataTripDriver() {
      this.dataSourceTripDriver = [];
      let useStartDate = this.selectedDate?.[0];
      let useEndDate = this.selectedDate?.[1];
      if(this.activePeriod == 'รายเดือน') {
        useStartDate = this.selectedDate?.[0].startOf('month');
        useEndDate = this.selectedDate?.[1].endOf('month');
      } else if(this.activePeriod == 'รายปี') {
        useStartDate = this.selectedDate?.[0].startOf('year');
        useEndDate = this.selectedDate?.[1].endOf('year');
      }
      const getSumTripDriver = await UserService.getAllSumTripDriver(useStartDate?.format("DD/MM/YYYY"),useEndDate?.format("DD/MM/YYYY"));
      let dataSumTripDriver = getSumTripDriver;
      dataSumTripDriver?.forEach((item , index)=>{
        const data = {
          index: index + 1,
          driver: item.fullname.split('|')[0] + " " + item.fullname.split('|')[1],
          work: Number(item.work),
          hour: Number(item.day),
          income: "฿" + Number(item.driver_salary || 0).toLocaleString('en-US'),
          company_3rd: item.company_3rd,
          booking_business_type_id: item.booking_business_type_id,
        };
        this.dataSourceTripDriver.push(data);
      });
      this.paginatedDataTripDriver = this.dataSourceTripDriver
      this.paginatedDataTripDriver.total = this.dataSourceTripDriver.length;
    },
    async fetchDataWorkingDashboard(){
      let useStartDate = this.selectedDate?.[0];
      let useEndDate = this.selectedDate?.[1];
      if(this.activePeriod == 'รายเดือน') {
        useStartDate = this.selectedDate?.[0].startOf('month');
        useEndDate = this.selectedDate?.[1].endOf('month');
      } else if(this.activePeriod == 'รายปี') {
        useStartDate = this.selectedDate?.[0].startOf('year');
        useEndDate = this.selectedDate?.[1].endOf('year');
      }
      const getVehicleDashboard = await UserService.getAllVehicleDashboard(useStartDate?.format("DD/MM/YYYY"),useEndDate?.format("DD/MM/YYYY"));
      this.dataWorking = getVehicleDashboard;
      let dataSourceSumVehicle = [];
      getVehicleDashboard?.forEach((vehicle, index) => {
        const data = {
          plate_no: vehicle.plate_no,
          booking_no: vehicle.booking_no,
          business_type : vehicle?.business_type,
          driver: vehicle.fullname,
          booking_status: vehicle.booking_status,
          origin: vehicle.origin,
          destination: this.render_des(vehicle),
          status: vehicle.status,
        };
        dataSourceSumVehicle.push(data);
      });
      setTimeout(() => {
        this.paginatedDataWorking = dataSourceSumVehicle.sort((a, b) => {
          const aHasBooking = a.booking_no != null && a.booking_no !== '';
          const bHasBooking = b.booking_no != null && b.booking_no !== '';

          return Number(bHasBooking) - Number(aHasBooking);
        });
      }, 500);
      this.paginatedDataWorking.total = dataSourceSumVehicle.length;
    },
    filterAndGroupByFullname(array) {
      const filteredBookings = array.filter(item => {
          return (
              item.booking_id !== null 
          );
      });
      const filteredStatus = filteredBookings;
      const indexedBookings = filteredStatus.map((item, index) => {
        return { ...item, index: index + 1 }; // Add the index, starting from 1
      });

      return indexedBookings;
    },
    render_des(record){
      if (record.data_text_destination && record.data_text_destination !== "null") {
        const response = JSON.parse(record.data_text_destination);
        if (Array.isArray(response) && typeof response[0] === "object" && response[0] !== null) {
          return response.map(item => item.name ?? "").join(",");
        }else{
          return response.join(',')
        }
      }
    },
    rowClassName(record, index) {
      if (index < 5) {
        return 'top-five-row'
      }
      return ''
    },
    openTableModal({ title, subTitle, footer = null, typeData, columns, data, loading = false }) {
      this.modalTitle = title;
      this.modalSubtitle = subTitle;
      this.modalFooter = footer;
      this.modalColumns = columns;
      this.modalLoading = loading;
      this.modalTypeData = typeData;
      this.modalVisible = true;
    },
    async loadPage() {
      this.sheetFetch = await SheetService.get_sheets();
      // this.onlineDrivers = await ;
      const companyData = JSON.parse(localStorage.getItem('companyData'));
      this.businessTypeId = companyData?.business_type_id;
      this.carCompanyList = await SystemService.get_all('CarCompany');
      this.work_status = await SystemService.get_all('WorkStatus');
    },
  },
  async mounted() {
    this.connectSocket();
    await this.loadPage();
    await this.updateChart();
  },
  unmounted() {
    this.leaveRoom('dashboard');
    this.leaveRoom('booking');
  },
  beforeUnmount() {
    this.chart_elements.forEach((el) => {
      if (el.chart) {
        el.chart?.destroy(); // ทำลาย chart ทำลาย component
      }
    });
  }
};


</script>

<style lang="scss" scoped>
  .pill-switch {
    display: inline-flex;
    background: #f5f5f5;
    padding: 4px;
    border-radius: 10px;
    gap: 4px;
  }

  .pill-switch span {
    padding: 6px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    color: #595959;
    transition: all 0.2s ease;
  }

  .pill-switch span:hover {
    color: #1677ff;
  }

  .pill-switch .active {
    background: #1677ff;
    color: white;
    box-shadow: 0 2px 6px rgba(22, 119, 255, 0.35);
  }

   .pill-switch-2 {
    display: inline-flex;
    background: #f5f5f5;
    padding: 4px;
    border-radius: 10px;
    gap: 4px;
  }

  .pill-switch-2 span {
    padding: 6px 16px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    color: #595959;
    transition: all 0.2s ease;
  }

  /* Status pill for modal table */
  .status-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
  }

  .status-pill .pill-icon { font-size: 18px; }

  .status-in {
    background-color: #E9FFF0;
    border: 1px solid rgba(34,197,94,0.14);
    color: #0f9d58;
  }

  .status-out {
    background-color: #FFF5F6;
    border: 1px solid rgba(255,77,79,0.12);
    color: #cf1322;
  }

  .status-neutral {
    background-color: #f3f4f6;
    border: 1px solid rgba(0,0,0,0.06);
    color: #333;
  }

  .pill-switch-2 span:hover {
    color: #9810fa;
  }

  .pill-switch-2 .active {
    background: #9810fa;
    color: white;
    box-shadow: 0 4px 10px rgba(88, 28, 135, 0.45);
  }
  
  .sticky-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: #fff;
  }

  .sticky-header {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .dashboard-header{
    padding: 16px;
    margin-bottom: 16px;
  }

  .summary-cards{
    margin-left: 12px;
    margin-right: 12px;
  }

  .avatar-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 10px;
    border-radius: 8px;
  }

  .avatar-icon-2 {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 10px;
    border-radius: 25px;
  }

  .card-value{
    font-size: 25px;
  }

  .trip {
    background: #155dfc;
    color: white;
    padding-top: 15px;
    font-size: 20px;
    font-weight: 500;
    border: 2px solid #f0f0f0;
    border-radius: 10px;
    margin-top: 12px;
  }

  .custom-table :deep(.ant-table-thead > tr > th) {
    background-color: #e6f4ff;
    color: #000;
  }

  .custom-card-header :deep(.ant-card-head) {
    background-color: #155dfc;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    color: white;
  }

  .most-car :deep(.ant-card-body) {
    padding: 0px;
  }

  :deep(.top-five-row td) {
    background-color: #e6f4ff;
  }
  
  .view-all {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.864);
    cursor: pointer;
  }

  .view-all:hover {
    text-decoration: underline;
  }

  .custom-legend {
    width: 100%;
    margin: 12px 0;
  }

  .legend-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 6px 0;
  }

  .legend-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .legend-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .legend-value {
    font-weight: 500;
  }

  .ui-locked {
    pointer-events: none;
    user-select: none;
  }

  .pill-switch,
  .pill-switch-2 {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .rank-badge {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    border-radius: 50%;
    background: #f6f3f4;
  }

  .rank-badge.top5 {
    background: #155dfc;
    color: #fff;
    border-radius: 50%;
  }
  .dashboard-overlay {
    position: fixed;
    inset: 0;
    z-index: 2000;
    background: rgba(255, 255, 255, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: all; /* overlay รับ click แทน */
  }
  .gradient-btn,
  .gradient-btn.ant-btn {
    background: linear-gradient(135deg, #00e676, #00a63e);
    border: none;
    color: white;
    font-weight: 500;
  }

  .gradient-btn:hover,
  .gradient-btn.ant-btn:hover,
  .gradient-btn.ant-btn:focus,
  .gradient-btn.ant-btn:active {
    background: linear-gradient(135deg, #00a63e, #007a2b);
    border: none;
    color: white;
    box-shadow: none;
  }
</style>